(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aYmkr", function(module, exports) {

var $5JLux = parcelRequire("5JLux");
// Docs got his can be found here
// https://dixonandmoe.com/rellax/
// or here
// https://github.com/dixonandmoe/rellax
var rellax = new (0, (/*@__PURE__*/$parcel$interopDefault($5JLux)))('.rellax');
if (document.querySelector('.scroll-container')) {
    // if mobile return
    return;
    function scroll() {
        // We only update the scroll position variables
        sx = window.pageXOffset;
        sy = window.pageYOffset;
    }
    function render() {
        // We calculate our container position by using our Linear Interpolation method.
        dx = lerp(dx, sx, 0.05);
        dy = lerp(dy, sy, 0.05);
        dx = Math.floor(dx * 100) / 100;
        dy = Math.floor(dy * 100) / 100;
        // Finally we translate our container to its new positions.
        // Don't forget to add a minus sign because the container needs to move in
        // the opposite direction of the window scroll.
        main.style.transform = `translate(-${dx}px, -${dy}px)`;
        // And we loop again.
        window.requestAnimationFrame(render);
    }
    // This is our Linear Interpolation method.
    function lerp(a, b, n) {
        return (1 - n) * a + n * b;
    }
}

});
parcelRegister("5JLux", function(module, exports) {
// ------------------------------------------
// Rellax.js
// Buttery smooth parallax library
// Copyright (c) 2016 Moe Amaya (@moeamaya)
// MIT license
//
// Thanks to Paraxify.js and Jaime Cabllero
// for parallax concepts
// ------------------------------------------
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.Rellax = factory();
})(typeof window !== "undefined" ? window : $parcel$global, function() {
    var Rellax = function(el, options) {
        "use strict";
        var self = Object.create(Rellax.prototype);
        var posY = 0;
        var screenY = 0;
        var posX = 0;
        var screenX = 0;
        var blocks = [];
        var pause = true;
        // check what requestAnimationFrame to use, and if
        // it's not supported, use the onscroll event
        var loop = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(callback) {
            return setTimeout(callback, 1000 / 60);
        };
        // store the id for later use
        var loopId = null;
        // Test via a getter in the options object to see if the passive property is accessed
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassive = true;
                }
            });
            window.addEventListener("testPassive", null, opts);
            window.removeEventListener("testPassive", null, opts);
        } catch (e) {}
        // check what cancelAnimation method to use
        var clearLoop = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout;
        // check which transform property to use
        var transformProp = window.transformProp || function() {
            var testEl = document.createElement('div');
            if (testEl.style.transform === null) {
                var vendors = [
                    'Webkit',
                    'Moz',
                    'ms'
                ];
                for(var vendor in vendors){
                    if (testEl.style[vendors[vendor] + 'Transform'] !== undefined) return vendors[vendor] + 'Transform';
                }
            }
            return 'transform';
        }();
        // Default Settings
        self.options = {
            speed: -2,
            verticalSpeed: null,
            horizontalSpeed: null,
            breakpoints: [
                576,
                768,
                1201
            ],
            center: false,
            wrapper: null,
            relativeToWrapper: false,
            round: true,
            vertical: true,
            horizontal: false,
            verticalScrollAxis: "y",
            horizontalScrollAxis: "x",
            callback: function() {}
        };
        // User defined options (might have more in the future)
        if (options) Object.keys(options).forEach(function(key) {
            self.options[key] = options[key];
        });
        function validateCustomBreakpoints() {
            if (self.options.breakpoints.length === 3 && Array.isArray(self.options.breakpoints)) {
                var isAscending = true;
                var isNumerical = true;
                var lastVal;
                self.options.breakpoints.forEach(function(i) {
                    if (typeof i !== 'number') isNumerical = false;
                    if (lastVal !== null) {
                        if (i < lastVal) isAscending = false;
                    }
                    lastVal = i;
                });
                if (isAscending && isNumerical) return;
            }
            // revert defaults if set incorrectly
            self.options.breakpoints = [
                576,
                768,
                1201
            ];
            console.warn("Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted");
        }
        if (options && options.breakpoints) validateCustomBreakpoints();
        // By default, rellax class
        if (!el) el = '.rellax';
        // check if el is a className or a node
        var elements = typeof el === 'string' ? document.querySelectorAll(el) : [
            el
        ];
        // Now query selector
        if (elements.length > 0) self.elems = elements;
        else {
            console.warn("Rellax: The elements you're trying to select don't exist.");
            return;
        }
        // Has a wrapper and it exists
        if (self.options.wrapper) {
            if (!self.options.wrapper.nodeType) {
                var wrapper = document.querySelector(self.options.wrapper);
                if (wrapper) self.options.wrapper = wrapper;
                else {
                    console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
                    return;
                }
            }
        }
        // set a placeholder for the current breakpoint
        var currentBreakpoint;
        // helper to determine current breakpoint
        var getCurrentBreakpoint = function(w) {
            var bp = self.options.breakpoints;
            if (w < bp[0]) return 'xs';
            if (w >= bp[0] && w < bp[1]) return 'sm';
            if (w >= bp[1] && w < bp[2]) return 'md';
            return 'lg';
        };
        // Get and cache initial position of all elements
        var cacheBlocks = function() {
            for(var i = 0; i < self.elems.length; i++){
                var block = createBlock(self.elems[i]);
                blocks.push(block);
            }
        };
        // Let's kick this script off
        // Build array for cached element values
        var init = function() {
            for(var i = 0; i < blocks.length; i++)self.elems[i].style.cssText = blocks[i].style;
            blocks = [];
            screenY = window.innerHeight;
            screenX = window.innerWidth;
            currentBreakpoint = getCurrentBreakpoint(screenX);
            setPosition();
            cacheBlocks();
            animate();
            // If paused, unpause and set listener for window resizing events
            if (pause) {
                window.addEventListener('resize', init);
                pause = false;
                // Start the loop
                update();
            }
        };
        // We want to cache the parallax blocks'
        // values: base, top, height, speed
        // el: is dom object, return: el cache values
        var createBlock = function(el) {
            var dataPercentage = el.getAttribute('data-rellax-percentage');
            var dataSpeed = el.getAttribute('data-rellax-speed');
            var dataXsSpeed = el.getAttribute('data-rellax-xs-speed');
            var dataMobileSpeed = el.getAttribute('data-rellax-mobile-speed');
            var dataTabletSpeed = el.getAttribute('data-rellax-tablet-speed');
            var dataDesktopSpeed = el.getAttribute('data-rellax-desktop-speed');
            var dataVerticalSpeed = el.getAttribute('data-rellax-vertical-speed');
            var dataHorizontalSpeed = el.getAttribute('data-rellax-horizontal-speed');
            var dataVericalScrollAxis = el.getAttribute('data-rellax-vertical-scroll-axis');
            var dataHorizontalScrollAxis = el.getAttribute('data-rellax-horizontal-scroll-axis');
            var dataZindex = el.getAttribute('data-rellax-zindex') || 0;
            var dataMin = el.getAttribute('data-rellax-min');
            var dataMax = el.getAttribute('data-rellax-max');
            var dataMinX = el.getAttribute('data-rellax-min-x');
            var dataMaxX = el.getAttribute('data-rellax-max-x');
            var dataMinY = el.getAttribute('data-rellax-min-y');
            var dataMaxY = el.getAttribute('data-rellax-max-y');
            var mapBreakpoints;
            var breakpoints = true;
            if (!dataXsSpeed && !dataMobileSpeed && !dataTabletSpeed && !dataDesktopSpeed) breakpoints = false;
            else mapBreakpoints = {
                'xs': dataXsSpeed,
                'sm': dataMobileSpeed,
                'md': dataTabletSpeed,
                'lg': dataDesktopSpeed
            };
            // initializing at scrollY = 0 (top of browser), scrollX = 0 (left of browser)
            // ensures elements are positioned based on HTML layout.
            //
            // If the element has the percentage attribute, the posY and posX needs to be
            // the current scroll position's value, so that the elements are still positioned based on HTML layout
            var wrapperPosY = self.options.wrapper ? self.options.wrapper.scrollTop : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            // If the option relativeToWrapper is true, use the wrappers offset to top, subtracted from the current page scroll.
            if (self.options.relativeToWrapper) {
                var scrollPosY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                wrapperPosY = scrollPosY - self.options.wrapper.offsetTop;
            }
            var posY = self.options.vertical ? dataPercentage || self.options.center ? wrapperPosY : 0 : 0;
            var posX = self.options.horizontal ? dataPercentage || self.options.center ? self.options.wrapper ? self.options.wrapper.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft : 0 : 0;
            var blockTop = posY + el.getBoundingClientRect().top;
            var blockHeight = el.clientHeight || el.offsetHeight || el.scrollHeight;
            var blockLeft = posX + el.getBoundingClientRect().left;
            var blockWidth = el.clientWidth || el.offsetWidth || el.scrollWidth;
            // apparently parallax equation everyone uses
            var percentageY = dataPercentage ? dataPercentage : (posY - blockTop + screenY) / (blockHeight + screenY);
            var percentageX = dataPercentage ? dataPercentage : (posX - blockLeft + screenX) / (blockWidth + screenX);
            if (self.options.center) {
                percentageX = 0.5;
                percentageY = 0.5;
            }
            // Optional individual block speed as data attr, otherwise global speed
            var speed = breakpoints && mapBreakpoints[currentBreakpoint] !== null ? Number(mapBreakpoints[currentBreakpoint]) : dataSpeed ? dataSpeed : self.options.speed;
            var verticalSpeed = dataVerticalSpeed ? dataVerticalSpeed : self.options.verticalSpeed;
            var horizontalSpeed = dataHorizontalSpeed ? dataHorizontalSpeed : self.options.horizontalSpeed;
            // Optional individual block movement axis direction as data attr, otherwise gobal movement direction
            var verticalScrollAxis = dataVericalScrollAxis ? dataVericalScrollAxis : self.options.verticalScrollAxis;
            var horizontalScrollAxis = dataHorizontalScrollAxis ? dataHorizontalScrollAxis : self.options.horizontalScrollAxis;
            var bases = updatePosition(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed);
            // ~~Store non-translate3d transforms~~
            // Store inline styles and extract transforms
            var style = el.style.cssText;
            var transform = '';
            // Check if there's an inline styled transform
            var searchResult = /transform\s*:/i.exec(style);
            if (searchResult) {
                // Get the index of the transform
                var index = searchResult.index;
                // Trim the style to the transform point and get the following semi-colon index
                var trimmedStyle = style.slice(index);
                var delimiter = trimmedStyle.indexOf(';');
                // Remove "transform" string and save the attribute
                if (delimiter) transform = " " + trimmedStyle.slice(11, delimiter).replace(/\s/g, '');
                else transform = " " + trimmedStyle.slice(11).replace(/\s/g, '');
            }
            return {
                baseX: bases.x,
                baseY: bases.y,
                top: blockTop,
                left: blockLeft,
                height: blockHeight,
                width: blockWidth,
                speed: speed,
                verticalSpeed: verticalSpeed,
                horizontalSpeed: horizontalSpeed,
                verticalScrollAxis: verticalScrollAxis,
                horizontalScrollAxis: horizontalScrollAxis,
                style: style,
                transform: transform,
                zindex: dataZindex,
                min: dataMin,
                max: dataMax,
                minX: dataMinX,
                maxX: dataMaxX,
                minY: dataMinY,
                maxY: dataMaxY
            };
        };
        // set scroll position (posY, posX)
        // side effect method is not ideal, but okay for now
        // returns true if the scroll changed, false if nothing happened
        var setPosition = function() {
            var oldY = posY;
            var oldX = posX;
            posY = self.options.wrapper ? self.options.wrapper.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
            posX = self.options.wrapper ? self.options.wrapper.scrollLeft : (document.documentElement || document.body.parentNode || document.body).scrollLeft || window.pageXOffset;
            // If option relativeToWrapper is true, use relative wrapper value instead.
            if (self.options.relativeToWrapper) {
                var scrollPosY = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
                posY = scrollPosY - self.options.wrapper.offsetTop;
            }
            if (oldY != posY && self.options.vertical) // scroll changed, return true
            return true;
            if (oldX != posX && self.options.horizontal) // scroll changed, return true
            return true;
            // scroll did not change
            return false;
        };
        // Ahh a pure function, gets new transform value
        // based on scrollPosition and speed
        // Allow for decimal pixel values
        var updatePosition = function(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed) {
            var result = {};
            var valueX = (horizontalSpeed ? horizontalSpeed : speed) * (100 * (1 - percentageX));
            var valueY = (verticalSpeed ? verticalSpeed : speed) * (100 * (1 - percentageY));
            result.x = self.options.round ? Math.round(valueX) : Math.round(valueX * 100) / 100;
            result.y = self.options.round ? Math.round(valueY) : Math.round(valueY * 100) / 100;
            return result;
        };
        // Remove event listeners and loop again
        var deferredUpdate = function() {
            window.removeEventListener('resize', deferredUpdate);
            window.removeEventListener('orientationchange', deferredUpdate);
            (self.options.wrapper ? self.options.wrapper : window).removeEventListener('scroll', deferredUpdate);
            (self.options.wrapper ? self.options.wrapper : document).removeEventListener('touchmove', deferredUpdate);
            // loop again
            loopId = loop(update);
        };
        // Loop
        var update = function() {
            if (setPosition() && pause === false) {
                animate();
                // loop again
                loopId = loop(update);
            } else {
                loopId = null;
                // Don't animate until we get a position updating event
                window.addEventListener('resize', deferredUpdate);
                window.addEventListener('orientationchange', deferredUpdate);
                (self.options.wrapper ? self.options.wrapper : window).addEventListener('scroll', deferredUpdate, supportsPassive ? {
                    passive: true
                } : false);
                (self.options.wrapper ? self.options.wrapper : document).addEventListener('touchmove', deferredUpdate, supportsPassive ? {
                    passive: true
                } : false);
            }
        };
        // Transform3d on parallax element
        var animate = function() {
            var positions;
            for(var i = 0; i < self.elems.length; i++){
                // Determine relevant movement directions
                var verticalScrollAxis = blocks[i].verticalScrollAxis.toLowerCase();
                var horizontalScrollAxis = blocks[i].horizontalScrollAxis.toLowerCase();
                var verticalScrollX = verticalScrollAxis.indexOf("x") != -1 ? posY : 0;
                var verticalScrollY = verticalScrollAxis.indexOf("y") != -1 ? posY : 0;
                var horizontalScrollX = horizontalScrollAxis.indexOf("x") != -1 ? posX : 0;
                var horizontalScrollY = horizontalScrollAxis.indexOf("y") != -1 ? posX : 0;
                var percentageY = (verticalScrollY + horizontalScrollY - blocks[i].top + screenY) / (blocks[i].height + screenY);
                var percentageX = (verticalScrollX + horizontalScrollX - blocks[i].left + screenX) / (blocks[i].width + screenX);
                // Subtracting initialize value, so element stays in same spot as HTML
                positions = updatePosition(percentageX, percentageY, blocks[i].speed, blocks[i].verticalSpeed, blocks[i].horizontalSpeed);
                var positionY = positions.y - blocks[i].baseY;
                var positionX = positions.x - blocks[i].baseX;
                // The next two "if" blocks go like this:
                // Check if a limit is defined (first "min", then "max");
                // Check if we need to change the Y or the X
                // (Currently working only if just one of the axes is enabled)
                // Then, check if the new position is inside the allowed limit
                // If so, use new position. If not, set position to limit.
                // Check if a min limit is defined
                if (blocks[i].min !== null) {
                    if (self.options.vertical && !self.options.horizontal) positionY = positionY <= blocks[i].min ? blocks[i].min : positionY;
                    if (self.options.horizontal && !self.options.vertical) positionX = positionX <= blocks[i].min ? blocks[i].min : positionX;
                }
                // Check if directional min limits are defined
                if (blocks[i].minY != null) positionY = positionY <= blocks[i].minY ? blocks[i].minY : positionY;
                if (blocks[i].minX != null) positionX = positionX <= blocks[i].minX ? blocks[i].minX : positionX;
                // Check if a max limit is defined
                if (blocks[i].max !== null) {
                    if (self.options.vertical && !self.options.horizontal) positionY = positionY >= blocks[i].max ? blocks[i].max : positionY;
                    if (self.options.horizontal && !self.options.vertical) positionX = positionX >= blocks[i].max ? blocks[i].max : positionX;
                }
                // Check if directional max limits are defined
                if (blocks[i].maxY != null) positionY = positionY >= blocks[i].maxY ? blocks[i].maxY : positionY;
                if (blocks[i].maxX != null) positionX = positionX >= blocks[i].maxX ? blocks[i].maxX : positionX;
                var zindex = blocks[i].zindex;
                // Move that element
                // (Set the new translation and append initial inline transforms.)
                var translate = 'translate3d(' + (self.options.horizontal ? positionX : '0') + 'px,' + (self.options.vertical ? positionY : '0') + 'px,' + zindex + 'px) ' + blocks[i].transform;
                self.elems[i].style[transformProp] = translate;
            }
            self.options.callback(positions);
        };
        self.destroy = function() {
            for(var i = 0; i < self.elems.length; i++)self.elems[i].style.cssText = blocks[i].style;
            // Remove resize event listener if not pause, and pause
            if (!pause) {
                window.removeEventListener('resize', init);
                pause = true;
            }
            // Clear the animation loop to prevent possible memory leak
            clearLoop(loopId);
            loopId = null;
        };
        // Init
        init();
        // Allow to recalculate the initial values whenever we want
        self.refresh = init;
        return self;
    };
    return Rellax;
});

});


// Vendors
var $f09ecb2bbe34e32f$exports = {};
!function(n, t) {
    $f09ecb2bbe34e32f$exports = t();
}($f09ecb2bbe34e32f$exports, function() {
    "use strict";
    function n(n) {
        return "number" == typeof n;
    }
    function t(n) {
        return "string" == typeof n;
    }
    function e(n) {
        return "boolean" == typeof n;
    }
    function r(n) {
        return "[object Object]" === Object.prototype.toString.call(n);
    }
    function o(n) {
        return Math.abs(n);
    }
    function i(n) {
        return Math.sign(n);
    }
    function c(n, t) {
        return o(n - t);
    }
    function u(n) {
        return l(n).map(Number);
    }
    function s(n) {
        return n[a(n)];
    }
    function a(n) {
        return Math.max(0, n.length - 1);
    }
    function l(n) {
        return Object.keys(n);
    }
    function d(n, t) {
        return [
            n,
            t
        ].reduce((n, t)=>(l(t).forEach((e)=>{
                const o = n[e], i = t[e], c = r(o) && r(i);
                n[e] = c ? d(o, i) : i;
            }), n), {});
    }
    function f(n, t) {
        return void 0 !== t.MouseEvent && n instanceof t.MouseEvent;
    }
    function p(t, e) {
        const r = {
            start: function() {
                return 0;
            },
            center: function(n) {
                return o(n) / 2;
            },
            end: o
        };
        function o(n) {
            return e - n;
        }
        return {
            measure: function(o) {
                return n(t) ? e * Number(t) : r[t](o);
            }
        };
    }
    function m(n, t) {
        const e = o(n - t);
        function r(t) {
            return t < n;
        }
        function i(n) {
            return n > t;
        }
        function c(n) {
            return r(n) || i(n);
        }
        return {
            length: e,
            max: t,
            min: n,
            constrain: function(e) {
                return c(e) ? r(e) ? n : t : e;
            },
            reachedAny: c,
            reachedMax: i,
            reachedMin: r,
            removeOffset: function(n) {
                return e ? n - e * Math.ceil((n - t) / e) : n;
            }
        };
    }
    function g(n, t, e) {
        const { constrain: r } = m(0, n), i = n + 1;
        let c = u(t);
        function u(n) {
            return e ? o((i + n) % i) : r(n);
        }
        function s() {
            return c;
        }
        function a() {
            return g(n, s(), e);
        }
        const l = {
            get: s,
            set: function(n) {
                return c = u(n), l;
            },
            add: function(n) {
                return a().set(s() + n);
            },
            clone: a
        };
        return l;
    }
    function h() {
        let n = [];
        const t = {
            add: function(e, r, o, i = {
                passive: !0
            }) {
                return e.addEventListener(r, o, i), n.push(()=>e.removeEventListener(r, o, i)), t;
            },
            clear: function() {
                n = n.filter((n)=>n());
            }
        };
        return t;
    }
    function x(n, t, r, u, s, a, l, d, p, g, x, y, v, b, S, w, E, D, M) {
        const { cross: A } = n, I = [
            "INPUT",
            "SELECT",
            "TEXTAREA"
        ], O = {
            passive: !1
        }, P = h(), T = h(), F = m(50, 225).constrain(S.measure(20)), z = {
            mouse: 300,
            touch: 400
        }, B = {
            mouse: 500,
            touch: 600
        }, L = w ? 43 : 25;
        let k = !1, H = 0, R = 0, N = !1, C = !1, V = !1, j = !1;
        function q(n) {
            const e = l.readPoint(n), r = l.readPoint(n, A), o = c(e, H), i = c(r, R);
            if (!C && !j) {
                if (!n.cancelable) return U(n);
                if (C = o > i, !C) return U(n);
            }
            const u = l.pointerMove(n);
            o > E && (V = !0), x.useFriction(.3).useDuration(1), p.start(), a.add(t.apply(u)), n.preventDefault();
        }
        function U(n) {
            const e = y.byDistance(0, !1).index !== v.get(), r = l.pointerUp(n) * (w ? B : z)[j ? "mouse" : "touch"], u = function(n, t) {
                const e = v.add(-1 * i(n)), r = y.byDistance(n, !w).distance;
                return w || o(n) < F ? r : D && t ? .5 * r : y.byIndex(e.get(), 0).distance;
            }(t.apply(r), e), s = function(n, t) {
                if (0 === n || 0 === t) return 0;
                if (o(n) <= o(t)) return 0;
                const e = c(o(n), o(t));
                return o(e / n);
            }(r, u), a = L - 10 * s, d = M + s / 50;
            C = !1, N = !1, T.clear(), x.useDuration(a).useFriction(d), g.distance(u, !w), j = !1, b.emit("pointerUp");
        }
        function W(n) {
            V && (n.stopPropagation(), n.preventDefault());
        }
        return {
            init: function(n, t) {
                if (!t) return;
                function o(o) {
                    (e(t) || t(n, o)) && function(n) {
                        const t = f(n, s);
                        if (j = t, t && 0 !== n.button) return;
                        if (function(n) {
                            const t = n.nodeName || "";
                            return I.includes(t);
                        }(n.target)) return;
                        V = w && t && !n.buttons && k, k = c(a.get(), d.get()) >= 2, N = !0, l.pointerDown(n), x.useFriction(0).useDuration(0), a.set(d), function() {
                            const n = j ? u : r;
                            T.add(n, "touchmove", q, O).add(n, "touchend", U).add(n, "mousemove", q, O).add(n, "mouseup", U);
                        }(), H = l.readPoint(n), R = l.readPoint(n, A), b.emit("pointerDown");
                    }(o);
                }
                const i = r;
                P.add(i, "dragstart", (n)=>n.preventDefault(), O).add(i, "touchmove", ()=>{}, O).add(i, "touchend", ()=>{}).add(i, "touchstart", o).add(i, "mousedown", o).add(i, "touchcancel", U).add(i, "contextmenu", U).add(i, "click", W, !0);
            },
            pointerDown: function() {
                return N;
            },
            destroy: function() {
                P.clear(), T.clear();
            }
        };
    }
    function y(n, t) {
        let e, r;
        function i(n) {
            return n.timeStamp;
        }
        function c(e, r) {
            const o = "client" + ("x" === (r || n.scroll) ? "X" : "Y");
            return (f(e, t) ? e : e.touches[0])[o];
        }
        return {
            pointerDown: function(n) {
                return e = n, r = n, c(n);
            },
            pointerMove: function(n) {
                const t = c(n) - c(r), o = i(n) - i(e) > 170;
                return r = n, o && (e = n), t;
            },
            pointerUp: function(n) {
                if (!e || !r) return 0;
                const t = c(r) - c(e), u = i(n) - i(e), s = i(n) - i(r) > 170, a = t / u;
                return u && !s && o(a) > .1 ? a : 0;
            },
            readPoint: c
        };
    }
    function v(n, t, r, o, i) {
        let c, u, s = [], a = !1;
        function l(n) {
            return i.measureSize(n.getBoundingClientRect());
        }
        return {
            init: function(i, d) {
                if (!d) return;
                u = l(n), s = o.map(l), c = new ResizeObserver((c)=>{
                    a || (e(d) || d(i, c)) && function(e) {
                        for (const c of e){
                            const e = c.target === n, a = o.indexOf(c.target);
                            if ((e ? u : s[a]) !== l(e ? n : o[a])) {
                                r.requestAnimationFrame(()=>{
                                    i.reInit(), t.emit("resize");
                                });
                                break;
                            }
                        }
                    }(c);
                }), [
                    n
                ].concat(o).forEach((n)=>c.observe(n));
            },
            destroy: function() {
                c && c.disconnect(), a = !0;
            }
        };
    }
    function b(n, t, e, r, i) {
        const c = i.measure(10), u = i.measure(50), s = m(.1, .99);
        let a = !1;
        return {
            constrain: function(i) {
                if (a || !n.reachedAny(e.get()) || !n.reachedAny(t.get())) return;
                const l = n.reachedMin(t.get()) ? "min" : "max", d = o(n[l] - t.get()), f = e.get() - t.get(), p = s.constrain(d / u);
                e.subtract(f * p), !i && o(f) < c && (e.set(n.constrain(e.get())), r.useDuration(25).useBaseFriction());
            },
            toggleActive: function(n) {
                a = !n;
            }
        };
    }
    function S(n, t, e, r) {
        const o = m(-t + n, e[0]), i = e.map(o.constrain).map((n)=>parseFloat(n.toFixed(3)));
        return {
            snapsContained: function() {
                if (t <= n) return [
                    o.max
                ];
                if ("keepSnaps" === r) return i;
                const { min: e, max: c } = function() {
                    const n = i[0], t = s(i), e = i.lastIndexOf(n), r = i.indexOf(t) + 1;
                    return m(e, r);
                }();
                return i.slice(e, c);
            }()
        };
    }
    function w(n, t, e, r) {
        const o = t.min + .1, i = t.max + .1, { reachedMin: c, reachedMax: u } = m(o, i);
        return {
            loop: function(t) {
                if (!function(n) {
                    return 1 === n ? u(e.get()) : -1 === n && c(e.get());
                }(t)) return;
                const o = n * (-1 * t);
                r.forEach((n)=>n.add(o));
            }
        };
    }
    function E(n) {
        const { max: t, length: e } = n;
        return {
            get: function(n) {
                return (n - t) / -e;
            }
        };
    }
    function D(n, t, e, r, c) {
        const { reachedAny: u, removeOffset: s, constrain: a } = r;
        function l(n) {
            return n.concat().sort((n, t)=>o(n) - o(t))[0];
        }
        function d(t, r) {
            const o = [
                t,
                t + e,
                t - e
            ];
            if (!n) return o[0];
            if (!r) return l(o);
            return l(o.filter((n)=>i(n) === r));
        }
        return {
            byDistance: function(e, r) {
                const i = c.get() + e, { index: l, distance: f } = function(e) {
                    const r = n ? s(e) : a(e), i = t.map((n)=>n - r).map((n)=>d(n, 0)).map((n, t)=>({
                            diff: n,
                            index: t
                        })).sort((n, t)=>o(n.diff) - o(t.diff)), { index: c } = i[0];
                    return {
                        index: c,
                        distance: r
                    };
                }(i), p = !n && u(i);
                return !r || p ? {
                    index: l,
                    distance: e
                } : {
                    index: l,
                    distance: e + d(t[l] - f, 0)
                };
            },
            byIndex: function(n, e) {
                return {
                    index: n,
                    distance: d(t[n] - c.get(), e)
                };
            },
            shortcut: d
        };
    }
    function M(t) {
        let e = t;
        function r(t) {
            return n(t) ? t : t.get();
        }
        return {
            get: function() {
                return e;
            },
            set: function(n) {
                e = r(n);
            },
            add: function(n) {
                e += r(n);
            },
            subtract: function(n) {
                e -= r(n);
            }
        };
    }
    function A(n, t, e) {
        const r = "x" === n.scroll ? function(n) {
            return `translate3d(${n}px,0px,0px)`;
        } : function(n) {
            return `translate3d(0px,${n}px,0px)`;
        }, o = e.style;
        let i = !1;
        return {
            clear: function() {
                i || (o.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
            },
            to: function(n) {
                i || (o.transform = r(t.apply(n)));
            },
            toggleActive: function(n) {
                i = !n;
            }
        };
    }
    function I(n, t, e, r, o, i, c, s, a) {
        const l = u(o), d = u(o).reverse(), f = (function() {
            const n = i[0] - 1;
            return g(m(d, n), "end");
        })().concat(function() {
            const n = e - i[0] - 1;
            return g(m(l, n), "start");
        }());
        function p(n, t) {
            return n.reduce((n, t)=>n - o[t], t);
        }
        function m(n, t) {
            return n.reduce((n, e)=>p(n, t) > 0 ? n.concat([
                    e
                ]) : n, []);
        }
        function g(e, o) {
            const i = "start" === o, u = i ? -r : r, l = c.findSlideBounds([
                u
            ]);
            return e.map((e)=>{
                const o = i ? 0 : -r, c = i ? r : 0, u = l.filter((n)=>n.index === e)[0][i ? "end" : "start"], d = M(-1), f = A(n, t, a[e]);
                return {
                    index: e,
                    location: d,
                    translate: f,
                    target: ()=>s.get() > u ? o : c
                };
            });
        }
        return {
            canLoop: function() {
                return f.every(({ index: n })=>p(l.filter((t)=>t !== n), e) <= .1);
            },
            clear: function() {
                f.forEach((n)=>n.translate.clear());
            },
            loop: function() {
                f.forEach((n)=>{
                    const { target: t, translate: e, location: r } = n, o = t();
                    o !== r.get() && (e.to(o), r.set(o));
                });
            },
            loopPoints: f
        };
    }
    function O(n, t) {
        let r, o = !1;
        return {
            init: function(i, c) {
                c && (r = new MutationObserver((n)=>{
                    o || (e(c) || c(i, n)) && function(n) {
                        for (const e of n)if ("childList" === e.type) {
                            i.reInit(), t.emit("slidesChanged");
                            break;
                        }
                    }(n);
                }), r.observe(n, {
                    childList: !0
                }));
            },
            destroy: function() {
                r && r.disconnect(), o = !0;
            }
        };
    }
    function P(n, t, e, r, o, i, c) {
        const { removeOffset: u, constrain: s } = o, a = i ? [
            0,
            t,
            -t
        ] : [
            0
        ], l = d(a, c);
        function d(t, o) {
            const i = t || a, c = function(n) {
                const t = n || 0;
                return e.map((n)=>m(.5, n - .5).constrain(n * t));
            }(o);
            return i.reduce((t, o)=>{
                const i = r.map((t, r)=>({
                        start: t - e[r] + c[r] + o,
                        end: t + n - c[r] + o,
                        index: r
                    }));
                return t.concat(i);
            }, []);
        }
        return {
            check: function(n, t) {
                const e = i ? u(n) : s(n);
                return (t || l).reduce((n, t)=>{
                    const { index: r, start: o, end: i } = t;
                    return !n.includes(r) && o < e && i > e ? n.concat([
                        r
                    ]) : n;
                }, []);
            },
            findSlideBounds: d
        };
    }
    function T(t, e, r) {
        const o = n(r);
        return {
            groupSlides: function(n) {
                return o ? function(n, t) {
                    return u(n).filter((n)=>n % t == 0).map((e)=>n.slice(e, e + t));
                }(n, r) : function(n) {
                    return u(n).reduce((n, r)=>{
                        const o = e.slice(s(n), r + 1).reduce((n, t)=>n + t, 0);
                        return !r || o > t ? n.concat(r) : n;
                    }, []).map((t, e, r)=>n.slice(t, r[e + 1]));
                }(n);
            }
        };
    }
    function F(n, t, e, r, c, l, d, f) {
        const { align: F, axis: z, direction: B, startIndex: L, inViewThreshold: k, loop: H, duration: R, dragFree: N, dragThreshold: C, slidesToScroll: V, skipSnaps: j, containScroll: q } = l, U = t.getBoundingClientRect(), W = e.map((n)=>n.getBoundingClientRect()), $ = function(n) {
            const t = "rtl" === n ? -1 : 1;
            return {
                apply: function(n) {
                    return n * t;
                }
            };
        }(B), G = function(n, t) {
            const e = "y" === n ? "y" : "x";
            return {
                scroll: e,
                cross: "y" === n ? "x" : "y",
                startEdge: "y" === e ? "top" : "rtl" === t ? "right" : "left",
                endEdge: "y" === e ? "bottom" : "rtl" === t ? "left" : "right",
                measureSize: function(n) {
                    const { width: t, height: r } = n;
                    return "x" === e ? t : r;
                }
            };
        }(z, B), Q = G.measureSize(U), X = function(n) {
            return {
                measure: function(t) {
                    return n * (t / 100);
                }
            };
        }(Q), Y = p(F, Q), J = !H && !!q, K = H || !!q, { slideSizes: Z, slideSizesWithGaps: _ } = function(n, t, e, r, i, c) {
            const { measureSize: u, startEdge: l, endEdge: d } = n, f = e[0] && i, p = function() {
                if (!f) return 0;
                const n = e[0];
                return o(t[l] - n[l]);
            }(), m = function() {
                if (!f) return 0;
                const n = c.getComputedStyle(s(r));
                return parseFloat(n.getPropertyValue(`margin-${d}`));
            }(), g = e.map(u), h = e.map((n, t, e)=>{
                const r = !t, o = t === a(e);
                return r ? g[t] + p : o ? g[t] + m : e[t + 1][l] - n[l];
            }).map(o);
            return {
                slideSizes: g,
                slideSizesWithGaps: h
            };
        }(G, U, W, e, K, c), nn = T(Q, _, V), { snaps: tn, snapsAligned: en } = function(n, t, e, r, i, c, u) {
            const { startEdge: l, endEdge: d } = n, { groupSlides: f } = c, p = f(r).map((n)=>s(n)[d] - n[0][l]).map(o).map(t.measure), m = r.map((n)=>e[l] - n[l]).map((n)=>-o(n)), g = function() {
                const n = s(m) - s(i);
                return f(m).map((n)=>n[0]).map((t, e, r)=>{
                    const o = !e, i = e === a(r);
                    return u && o ? 0 : u && i ? n : t + p[e];
                });
            }();
            return {
                snaps: m,
                snapsAligned: g
            };
        }(G, Y, U, W, _, nn, J), rn = -s(tn) + s(_), { snapsContained: on } = S(Q, rn, en, q), cn = J ? on : en, { limit: un } = function(n, t, e) {
            const r = t[0];
            return {
                limit: m(e ? r - n : s(t), r)
            };
        }(rn, cn, H), sn = g(a(cn), L, H), an = sn.clone(), ln = u(e), dn = {
            update: ()=>(({ dragHandler: n, scrollBody: t, scrollBounds: e, scrollLooper: r, slideLooper: o, eventHandler: i, animation: c, options: { loop: u } })=>{
                    const s = n.pointerDown();
                    u || e.constrain(s);
                    const a = t.seek().settled();
                    a && !s && (c.stop(), i.emit("settle")), a || i.emit("scroll"), u && (r.loop(t.direction()), o.loop());
                })(vn),
            render: (n)=>(({ scrollBody: n, translate: t, location: e }, r)=>{
                    const o = n.velocity(), i = e.get() - o + o * r;
                    t.to(i);
                })(vn, n),
            start: ()=>f.start(vn),
            stop: ()=>f.stop(vn)
        }, fn = cn[sn.get()], pn = M(fn), mn = M(fn), gn = function(n, t, e, r) {
            let c = !0, u = 0, s = 0, a = e, l = r;
            function d(n) {
                return a = n, p;
            }
            function f(n) {
                return l = n, p;
            }
            const p = {
                direction: function() {
                    return s;
                },
                seek: function() {
                    const e = t.get() - n.get();
                    return l && a ? (u += e / a, u *= l, n.add(u)) : (u = 0, n.set(t)), s = i(u || e), c = o(e) < .001, p;
                },
                settled: function() {
                    return c && n.set(t), c;
                },
                useBaseFriction: function() {
                    return f(r);
                },
                useBaseDuration: function() {
                    return d(e);
                },
                useFriction: f,
                useDuration: d,
                velocity: function() {
                    return u;
                }
            };
            return p;
        }(pn, mn, R, .68), hn = D(H, cn, rn, un, mn), xn = function(n, t, e, r, o, i) {
            function c(r) {
                const c = r.distance, u = r.index !== t.get();
                c && (n.start(), o.add(c)), u && (e.set(t.get()), t.set(r.index), i.emit("select"));
            }
            return {
                distance: function(n, t) {
                    c(r.byDistance(n, t));
                },
                index: function(n, e) {
                    const o = t.clone().set(n);
                    c(r.byIndex(o.get(), e));
                }
            };
        }(dn, sn, an, hn, mn, d), yn = P(Q, rn, Z, tn, un, H, k), vn = {
            ownerDocument: r,
            ownerWindow: c,
            eventHandler: d,
            containerRect: U,
            slideRects: W,
            animation: dn,
            axis: G,
            direction: $,
            dragHandler: x(G, $, n, r, c, mn, y(G, c), pn, dn, xn, gn, hn, sn, d, X, N, C, j, .68),
            eventStore: h(),
            percentOfView: X,
            index: sn,
            indexPrevious: an,
            limit: un,
            location: pn,
            options: l,
            resizeHandler: v(t, d, c, e, G),
            scrollBody: gn,
            scrollBounds: b(un, pn, mn, gn, X),
            scrollLooper: w(rn, un, pn, [
                pn,
                mn
            ]),
            scrollProgress: E(un),
            scrollSnaps: cn,
            scrollTarget: hn,
            scrollTo: xn,
            slideLooper: I(G, $, Q, rn, _, cn, yn, pn, e),
            slidesHandler: O(t, d),
            slidesInView: yn,
            slideIndexes: ln,
            slidesToScroll: nn,
            target: mn,
            translate: A(G, $, t)
        };
        return vn;
    }
    const z = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: null,
        direction: "ltr",
        slidesToScroll: 1,
        breakpoints: {},
        dragFree: !1,
        dragThreshold: 10,
        inViewThreshold: 0,
        loop: !1,
        skipSnaps: !1,
        duration: 25,
        startIndex: 0,
        active: !0,
        watchDrag: !0,
        watchResize: !0,
        watchSlides: !0
    };
    function B(n) {
        function t(n, t) {
            return d(n, t || {});
        }
        const e = {
            mergeOptions: t,
            optionsAtMedia: function(e) {
                const r = e.breakpoints || {}, o = l(r).filter((t)=>n.matchMedia(t).matches).map((n)=>r[n]).reduce((n, e)=>t(n, e), {});
                return t(e, o);
            },
            optionsMediaQueries: function(t) {
                return t.map((n)=>l(n.breakpoints || {})).reduce((n, t)=>n.concat(t), []).map(n.matchMedia);
            }
        };
        return e;
    }
    function L(n, e, r) {
        const i = n.ownerDocument, c = i.defaultView, u = B(c), s = function(n) {
            let t = [];
            return {
                init: function(e, r) {
                    return t = e.filter(({ options: t })=>!1 !== n.optionsAtMedia(t).active), t.forEach((t)=>t.init(r, n)), e.reduce((n, t)=>Object.assign(n, {
                            [t.name]: t
                        }), {});
                },
                destroy: function() {
                    t = t.filter((n)=>n.destroy());
                }
            };
        }(u), a = h(), l = h(), d = function() {
            const n = {};
            let t;
            function e(t) {
                return n[t] || [];
            }
            const r = {
                init: function(n) {
                    t = n;
                },
                emit: function(n) {
                    return e(n).forEach((e)=>e(t, n)), r;
                },
                off: function(t, o) {
                    return n[t] = e(t).filter((n)=>n !== o), r;
                },
                on: function(t, o) {
                    return n[t] = e(t).concat([
                        o
                    ]), r;
                }
            };
            return r;
        }(), { animationRealms: f } = L, { mergeOptions: p, optionsAtMedia: m, optionsMediaQueries: g } = u, { on: x, off: y, emit: v } = d, b = T;
        let S, w, E, D, M = !1, A = p(z, L.globalOptions), I = p(A), O = [];
        function P(e, r) {
            if (M) return;
            const u = f.find((n)=>n.window === c), h = u || function(n) {
                const t = 1e3 / 60;
                let e = [], r = null, i = 0, c = 0;
                function u(s) {
                    r || (r = s);
                    const a = s - r;
                    for(r = s, i += a; i >= t;)e.forEach(({ animation: n })=>n.update()), i -= t;
                    const l = o(i / t);
                    e.forEach(({ animation: n })=>n.render(l)), c && n.requestAnimationFrame(u);
                }
                return {
                    start: function(t) {
                        e.includes(t) || e.push(t), c || (c = n.requestAnimationFrame(u));
                    },
                    stop: function(t) {
                        e = e.filter((n)=>n !== t), e.length || (n.cancelAnimationFrame(c), r = null, i = 0, c = 0);
                    },
                    reset: function() {
                        r = null, i = 0;
                    },
                    window: n
                };
            }(c);
            if (u || f.push(h), A = p(A, e), I = m(A), O = r || O, function() {
                const { container: e, slides: r } = I, o = t(e) ? n.querySelector(e) : e;
                E = o || n.children[0];
                const i = t(r) ? E.querySelectorAll(r) : r;
                D = [].slice.call(i || E.children);
            }(), S = F(n, E, D, i, c, I, d, h), g([
                A,
                ...O.map(({ options: n })=>n)
            ]).forEach((n)=>a.add(n, "change", T)), I.active) {
                if (S.translate.to(S.location.get()), S.eventHandler.init(C), S.resizeHandler.init(C, I.watchResize), S.slidesHandler.init(C, I.watchSlides), l.add(i, "visibilitychange", ()=>{
                    i.hidden && h.reset();
                }), I.loop) {
                    if (!S.slideLooper.canLoop()) return k(), P({
                        loop: !1
                    }, r), void (A = p(A, {
                        loop: !0
                    }));
                    S.slideLooper.loop();
                }
                E.offsetParent && D.length && S.dragHandler.init(C, I.watchDrag), w = s.init(O, C);
            }
        }
        function T(n, t) {
            const e = N();
            k(), P(p({
                startIndex: e
            }, n), t), d.emit("reInit");
        }
        function k() {
            S.dragHandler.destroy(), S.animation.stop(), S.eventStore.clear(), S.translate.clear(), S.slideLooper.clear(), S.resizeHandler.destroy(), S.slidesHandler.destroy(), s.destroy(), a.clear(), l.clear();
        }
        function H(n) {
            const t = S[n ? "target" : "location"].get(), e = I.loop ? "removeOffset" : "constrain";
            return S.slidesInView.check(S.limit[e](t));
        }
        function R(n, t, e) {
            I.active && !M && (S.scrollBody.useBaseFriction().useDuration(t ? 0 : I.duration), S.scrollTo.index(n, e || 0));
        }
        function N() {
            return S.index.get();
        }
        const C = {
            canScrollNext: function() {
                return S.index.add(1).get() !== N();
            },
            canScrollPrev: function() {
                return S.index.add(-1).get() !== N();
            },
            containerNode: function() {
                return E;
            },
            internalEngine: function() {
                return S;
            },
            destroy: function() {
                M || (M = !0, a.clear(), k(), d.emit("destroy"));
            },
            off: y,
            on: x,
            emit: v,
            plugins: function() {
                return w;
            },
            previousScrollSnap: function() {
                return S.indexPrevious.get();
            },
            reInit: b,
            rootNode: function() {
                return n;
            },
            scrollNext: function(n) {
                R(S.index.add(1).get(), !0 === n, -1);
            },
            scrollPrev: function(n) {
                R(S.index.add(-1).get(), !0 === n, 1);
            },
            scrollProgress: function() {
                return S.scrollProgress.get(S.location.get());
            },
            scrollSnapList: function() {
                return S.scrollSnaps.map(S.scrollProgress.get);
            },
            scrollTo: R,
            selectedScrollSnap: N,
            slideNodes: function() {
                return D;
            },
            slidesInView: H,
            slidesNotInView: function(n) {
                const t = H(n);
                return S.slideIndexes.filter((n)=>!t.includes(n));
            }
        };
        return P(e, r), setTimeout(()=>d.emit("init"), 0), C;
    }
    return L.animationRealms = [], L.globalOptions = void 0, L;
});
!function(n, o) {
    $f09ecb2bbe34e32f$exports = o();
}($f09ecb2bbe34e32f$exports, function() {
    "use strict";
    const n = {
        active: !0,
        breakpoints: {},
        delay: 4e3,
        jump: !1,
        playOnInit: !0,
        stopOnInteraction: !0,
        stopOnMouseEnter: !1,
        stopOnLastSnap: !1,
        rootNode: null
    };
    function o(t = {}) {
        let e, i, s, r = 0, a = !1;
        function p() {
            i.off("pointerDown", s), e.stopOnInteraction || i.off("pointerUp", u), d(), r = 0;
        }
        function l(n) {
            d(), void 0 !== n && (a = n), r = window.setTimeout(c, e.delay);
        }
        function d() {
            r && window.clearTimeout(r);
        }
        function u() {
            r && (d(), l());
        }
        function c() {
            const { index: n } = i.internalEngine(), o = i.scrollSnapList().length - 1;
            if (e.stopOnLastSnap && n.get() === o) return p();
            i.canScrollNext() ? i.scrollNext(a) : i.scrollTo(0, a), l();
        }
        return {
            name: "autoplay",
            options: t,
            init: function(r, c) {
                i = r;
                const { mergeOptions: f, optionsAtMedia: y } = c, O = f(n, o.globalOptions), m = f(O, t);
                e = y(m), a = e.jump, s = e.stopOnInteraction ? p : d;
                const { eventStore: g, ownerDocument: b, ownerWindow: w } = i.internalEngine(), h = i.rootNode(), v = e.rootNode && e.rootNode(h) || h;
                i.on("pointerDown", s), e.stopOnInteraction || i.on("pointerUp", u), e.stopOnMouseEnter && (g.add(v, "mouseenter", s), e.stopOnInteraction || g.add(v, "mouseleave", u)), g.add(b, "visibilitychange", ()=>{
                    if ("hidden" === b.visibilityState) return d();
                    u();
                }), g.add(w, "pagehide", (n)=>{
                    n.persisted && d();
                }), e.playOnInit && l();
            },
            destroy: p,
            play: l,
            stop: d,
            reset: u
        };
    }
    return o.globalOptions = void 0, o;
});


function $3fb125f96e5f3e5f$var$getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary)=>{
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    summary.addEventListener('click', (event)=>{
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', $3fb125f96e5f3e5f$export$8321c3cfa751e98e);
});
const $3fb125f96e5f3e5f$var$trapFocusHandlers = {};
function $3fb125f96e5f3e5f$export$bec45a54c2e66c22(container, elementToFocus = container) {
    var elements = $3fb125f96e5f3e5f$var$getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    $3fb125f96e5f3e5f$export$c761a6bf8c4188fe();
    $3fb125f96e5f3e5f$var$trapFocusHandlers.focusin = (event)=>{
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', $3fb125f96e5f3e5f$var$trapFocusHandlers.keydown);
    };
    $3fb125f96e5f3e5f$var$trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', $3fb125f96e5f3e5f$var$trapFocusHandlers.keydown);
    };
    $3fb125f96e5f3e5f$var$trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener('focusout', $3fb125f96e5f3e5f$var$trapFocusHandlers.focusout);
    document.addEventListener('focusin', $3fb125f96e5f3e5f$var$trapFocusHandlers.focusin);
    if (elementToFocus) elementToFocus.focus();
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    $3fb125f96e5f3e5f$var$focusVisiblePolyfill();
}
function $3fb125f96e5f3e5f$var$focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN'
    ];
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event)=>{
        if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
    });
    window.addEventListener('mousedown', (event)=>{
        mouseClick = true;
    });
    window.addEventListener('focus', ()=>{
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
        if (mouseClick) return;
        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
    }, true);
}
function $3fb125f96e5f3e5f$var$loadInVideos() {
    const videos = document.querySelectorAll(".js-autoplay");
    if (videos.length === 0) return;
    videos.forEach((video)=>{
        video.addEventListener("timeupdate", ()=>{
            setTimeout(()=>{
                video.classList.add("loaded");
            }, 50);
        }, {
            once: true
        });
    });
}
$3fb125f96e5f3e5f$var$loadInVideos();
function $3fb125f96e5f3e5f$export$df87d1b3660dd9f7() {
    document.querySelectorAll('.js-youtube').forEach((video)=>{
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video)=>{
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video:not(.js-autoplay)').forEach((video)=>{
        video.pause();
    });
    document.querySelectorAll('product-model').forEach((model)=>{
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}
function $3fb125f96e5f3e5f$export$c761a6bf8c4188fe(elementToFocus = null) {
    document.removeEventListener('focusin', $3fb125f96e5f3e5f$var$trapFocusHandlers.focusin);
    document.removeEventListener('focusout', $3fb125f96e5f3e5f$var$trapFocusHandlers.focusout);
    document.removeEventListener('keydown', $3fb125f96e5f3e5f$var$trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}
function $3fb125f96e5f3e5f$export$8321c3cfa751e98e(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}
class $3fb125f96e5f3e5f$var$QuantityInput extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        });
        this.isStickyForm = this.closest('sticky-cart') ? true : false;
        if (this.isStickyForm) {
            this.mainFormRef = document.querySelector('[data-product-details]');
            if (this.mainFormRef) this.mainFormQuantityRef = this.mainFormRef.querySelector('quantity-input input');
        } else {
            this.stickyFormRef = document.querySelector('sticky-cart');
            if (this.stickyFormRef) this.stickyFormQuantityRef = this.stickyFormRef.querySelector('quantity-input input');
        }
        this.querySelectorAll('button').forEach((button)=>button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        if (event.target.name === 'plus') {
            this.input.stepUp();
            if (this.stickyFormQuantityRef) this.stickyFormQuantityRef.stepUp();
            if (this.mainFormQuantityRef) this.mainFormQuantityRef.stepUp();
        } else {
            this.input.stepDown();
            if (this.stickyFormQuantityRef) this.stickyFormQuantityRef.stepDown();
            if (this.mainFormQuantityRef) this.mainFormQuantityRef.stepDown();
        }
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('quantity-input', $3fb125f96e5f3e5f$var$QuantityInput);
function $3fb125f96e5f3e5f$export$61fc7d43ac8f84b0(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
function $3fb125f96e5f3e5f$export$1811237fdf5ac5d(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}
/*
 * Shopify Common JS
 *
 */ if (typeof window.Shopify == 'undefined') window.Shopify = {};
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};
Shopify.setSelectorByValue = function(selector, value) {
    for(var i = 0, count = selector.options.length; i < count; i++){
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for(var key in params){
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },
    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
    },
    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) this.provinceContainer.style.display = 'none';
        else {
            for(var i = 0; i < provinces.length; i++){
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(selector) {
        while(selector.firstChild)selector.removeChild(selector.firstChild);
    },
    setOptions: function(selector, values) {
        for(var i = 0, count = values.length; i < values.length; i++){
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};
class $3fb125f96e5f3e5f$var$ProductRecommendations extends HTMLElement {
    observer = undefined;
    constructor(){
        super();
    }
    connectedCallback() {
        this.initializeRecommendations();
    }
    initializeRecommendations() {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver((entries, observer)=>{
            // if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations();
        }, {
            rootMargin: '0px 0px 400px 0px'
        });
        this.observer.observe(this);
    }
    loadRecommendations() {
        fetch(`${this.dataset.url}`).then((response)=>response.text()).then((text)=>{
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                const carousel = this.querySelector('embla-component');
                if (carousel) carousel.restart();
            }
        }).catch((e)=>{
            console.error(e);
        });
    }
}
customElements.define('product-recommendations', $3fb125f96e5f3e5f$var$ProductRecommendations);


/**
 * Utils: Animate
 * ------------------------------------------------------------------------------
 *
 * @namespace animate
 */ function $d5ef98599919884f$var$animate() {
    function scrollTrigger(selector, options = {}) {
        let els = document.querySelectorAll(selector);
        els = Array.from(els);
        els.forEach((el)=>{
            // Passing the options object to the addObserver function
            addObserver(el, options);
        });
    }
    // Receiving options passed from the scrollTrigger function
    function addObserver(el, options) {
        let observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    let delay = parseInt(entry.target.dataset.animateDelay) || 0;
                    if (document.querySelector('body').classList.contains('animate--none')) delay = 0;
                    setTimeout(()=>{
                        entry.target.classList.add('animated');
                        observer.unobserve(entry.target);
                    }, delay);
                }
            });
        }, options) // Passing the options object to the observer
        ;
        observer.observe(el);
    }
    function init() {
        scrollTrigger('.animate', {
            rootMargin: '-100px'
        });
    }
    if (window.designMode.enabled === 'true') document.addEventListener('shopify:section:load', ()=>{
        init();
    });
    /**
   * Expose public interface
   */ return Object.freeze({
        init: init
    });
}
document.addEventListener('DOMContentLoaded', function() {
// animate().init();
});



class $1c73d704d5705de4$var$MenuDrawer extends HTMLElement {
    constructor(){
        super();
        this.mainDetailsToggle = this.querySelector('details');
        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
        if (this.querySelector('.closer')) this.querySelector('.closer').addEventListener('click', (e)=>{
            this.closeMenuDrawer(e);
        });
        if (this.querySelector('.closer-desktop')) this.querySelector('.closer-desktop').addEventListener('click', (e)=>{
            this.closeMenuDrawer(e);
        });
    }
    bindEvents() {
        this.querySelectorAll('summary').forEach((summary)=>{
            summary.addEventListener('click', this.onSummaryClick.bind(this));
        });
        this.querySelectorAll('button').forEach((button)=>button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        function addTrapFocus() {
            // trapFocus(
            //   summaryElement.nextElementSibling,
            //   detailsElement.querySelector('button'),
            // );
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }
        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else setTimeout(()=>{
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            parentMenuElement && parentMenuElement.classList.add('submenu-open');
            !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
    }
    openMenuDrawer(summaryElement) {
        setTimeout(()=>{
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        // trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details)=>{
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu)=>{
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden`);
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }
    onFocusOut(event) {
        setTimeout(()=>{
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
        let animationStart;
        const handleAnimation = (time)=>{
            if (animationStart === undefined) animationStart = time;
            const elapsedTime = time - animationStart;
            if (elapsedTime < 400) window.requestAnimationFrame(handleAnimation);
            else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
            }
        };
        window.requestAnimationFrame(handleAnimation);
    }
}
customElements.define('menu-drawer', $1c73d704d5705de4$var$MenuDrawer);



class $107c1e4b92938bb0$var$HeaderDrawer extends HTMLElement {
    constructor(){
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.menuDrawer = this.querySelector('#menu-drawer');
        this.menuDrawerBackdrop = this.querySelector('#menu-drawer-backdrop');
        this.container = document.querySelector('.header-wrapper');
        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
        if (this.querySelector('.closer')) this.querySelector('.closer').addEventListener('click', (e)=>{
            this.closeMenuDrawer(e);
        });
        if (this.querySelector('.closer-desktop')) this.querySelector('.closer-desktop').addEventListener('click', (e)=>{
            this.closeMenuDrawer(e);
        });
        this.menuDrawerBackdrop.addEventListener('click', (event)=>{
            this.closeMenuDrawer(event);
        });
    }
    bindEvents() {
        this.querySelectorAll('summary').forEach((summary)=>{
            summary.addEventListener('click', this.onSummaryClick.bind(this));
        });
        this.querySelectorAll('button').forEach((button)=>button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }
        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else setTimeout(()=>{
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            parentMenuElement && parentMenuElement.classList.add('submenu-open');
            !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
    }
    updateHeaderElements() {
        const headerPosition = this.container.getBoundingClientRect();
        this.menuDrawer.style.marginTop = `-${headerPosition.top}px`;
        this.menuDrawerBackdrop.style.marginTop = `-${headerPosition.top}px`;
    }
    openMenuDrawer(summaryElement) {
        this.updateHeaderElements();
        setTimeout(()=>{
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        // trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details)=>{
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu)=>{
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden`);
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }
    onFocusOut(event) {
        setTimeout(()=>{
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
        let animationStart;
        const handleAnimation = (time)=>{
            if (animationStart === undefined) animationStart = time;
            const elapsedTime = time - animationStart;
            if (elapsedTime < 400) window.requestAnimationFrame(handleAnimation);
            else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
            }
        };
        window.requestAnimationFrame(handleAnimation);
    }
}
customElements.define('header-drawer', $107c1e4b92938bb0$var$HeaderDrawer);



if (!customElements.get('product-form')) customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const config = (0, $3fb125f96e5f3e5f$export$1811237fdf5ac5d)('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section)=>section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config).then((response)=>response.json()).then((response)=>{
            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message
                });
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
            } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
            }
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
                document.body.addEventListener('modalClosed', ()=>{
                    setTimeout(()=>{
                        this.cart.renderContents(response);
                    });
                }, {
                    once: true
                });
                quickAddModal.hide(true);
            } else this.cart.renderContents(response);
        }).catch((e)=>{
            console.error(e);
        }).finally(()=>{
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }
    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
    get variantIdInput() {
        return this.form.querySelector('[name=id]');
    }
});
class $661b1f04b5689b56$var$VariantLabel extends HTMLElement {
    constructor(){
        super();
        this.legend = this.querySelector('legend');
        this.legendVariant = this.legend.firstElementChild;
        this.optionPosition = Number(this.getAttribute('data-option-position'));
        this.variantParent = this.closest('variant-radios') || this.closest('variant-selects') || null;
        this.variants;
        if (this.variantParent) {
            this.variants = this.variantParent.querySelectorAll('input[type="radio"]');
            if (this.variants.length === 0) this.variants = this.variantParent.querySelectorAll('select');
        }
        if (this.parentElement.hasAttribute('data-sticky-add')) return;
        else document.addEventListener('DOMContentLoaded', (e)=>{
            this.markActiveVariant();
        });
    }
    markActiveVariant() {
        if (!this.variants) return;
        const variantsArr = [
            ...this.variants
        ];
        const activeVariant = variantsArr.find((variant)=>variant.hasAttribute('checked')) || variantsArr[0];
        if (!activeVariant) return;
        let checker = this.parentElement.hasAttribute('data-sticky-add');
        if (this.variantParent.nodeName === 'VARIANT-RADIOS' && checker == false) this.variantParent.onVariantChange(activeVariant, true, false);
        else if (this.variantParent.nodeName === 'VARIANT-SELECTS' && checker == false) this.variantParent.onVariantChange(activeVariant, true, false);
    }
    updateLegendVariant(options, isStickyForm, stickyFormRef, mainFormRef) {
        if (!options) return;
        this.legendVariant.textContent = options[this.optionPosition];
        if (!isStickyForm && stickyFormRef) stickyFormRef.querySelectorAll('variant-label')[this.optionPosition].querySelector('legend span').textContent = options[this.optionPosition];
        else if (mainFormRef) mainFormRef.querySelectorAll('variant-label')[this.optionPosition].querySelector('legend span').textContent = options[this.optionPosition];
    }
}
customElements.define('variant-label', $661b1f04b5689b56$var$VariantLabel);
class $661b1f04b5689b56$var$StockMessage extends HTMLElement {
    constructor(){
        super();
        this.lowStockThreshold = +this.getAttribute('data-low-stock');
        this.lowStockWrapper = this.querySelector('.js-stock-message');
        this.variantsInventories;
        this.getVariantInventories();
    }
    getVariantInventories() {
        const variantsData = this.getAttribute('data-variants-inventory');
        if (!variantsData) return;
        this.variantsInventories = variantsData.split('/').map((variant)=>variant.split(','));
    }
    updateLowStockMessage(variantId) {
        const foundVariant = this.variantsInventories.filter((variant)=>Number(variant[0]) === variantId).flat();
        if (!foundVariant) return;
        const foundVariantInventory = Number(foundVariant[1]);
        if (foundVariantInventory < this.lowStockThreshold && foundVariantInventory > 0) this.setAttribute('low-stock', '');
        else this.removeAttribute('low-stock');
    }
}
customElements.define('stock-message', $661b1f04b5689b56$var$StockMessage);
class $661b1f04b5689b56$var$VariantSelects extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('change', (e)=>this.onVariantChange(e.target));
        this.isStickyForm = this.getAttribute('data-is-sticky-cart') === 'true' ? true : false;
        this.mainFormRef = document.querySelector('[data-product-details]');
        if (this.mainFormRef) this.mainFormVariantsRef = this.mainFormRef.querySelector('variant-radios') || this.mainFormRef.querySelector('variant-selects') || null;
    }
    onVariantChange(targetEl, initialLoad = false) {
        this.updateOptions();
        this.updateMasterId();
        this.updateLegend(targetEl);
        this.updateStockMessage(targetEl);
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
            this.updateMedia(initialLoad);
        }
    }
    updateLegend(targetEl) {
        const variantLabel = targetEl.closest('[data-select-fieldset]')?.querySelector('variant-label') || targetEl.closest('fieldset')?.querySelector('variant-label') || null;
        if (variantLabel) variantLabel.updateLegendVariant(this.options, this.isStickyForm, this.stickyFormRef, this.mainFormRef);
    }
    updateStockMessage(targetEl) {
        const lowStockCustomEl = targetEl.querySelector('stock-message') || targetEl.closest('section') ? targetEl.closest('section').querySelector('stock-message') : null;
        if (!lowStockCustomEl || !this.currentVariant) return;
        lowStockCustomEl.updateLowStockMessage(this.currentVariant.id);
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select)=>select.value);
        if (this.isStickyForm) {
            if (this.mainFormVariantsRef) this.mainFormVariantsRef.options = this.options;
            else return;
            const allSelects = this.mainFormVariantsRef.querySelectorAll('select');
            if (allSelects.length > 0) {
                this.mainFormVariantsRef.options.forEach((option, index)=>{
                    allSelects[index].value = option;
                });
                return;
            }
            const allRadiosFieldsets = this.mainFormVariantsRef.querySelectorAll('fieldset');
            if (allRadiosFieldsets.length > 0) this.mainFormVariantsRef.options.forEach((option, index)=>{
                allRadiosFieldsets[index].querySelectorAll('input[type="radio"]').forEach((radio)=>{
                    radio.removeAttribute('checked');
                    if (radio.value === option) radio.setAttribute('checked', '');
                });
            });
        } else {
            if (this.stickyFormVariantsRef) this.stickyFormVariantsRef.options = this.options;
            else return;
            const allSelects = this.stickyFormVariantsRef.querySelectorAll('select');
            if (allSelects.length > 0) this.stickyFormVariantsRef.options.forEach((option, index)=>{
                allSelects[index].value = option;
            });
        }
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant)=>{
            return !variant.options.map((option, index)=>{
                return this.options[index] === option;
            }).includes(false);
        });
        if (!this.isStickyForm) {
            if (this.stickyFormVariantsRef) this.stickyFormVariantsRef.currentVariant = this.currentVariant;
        } else this.mainFormVariantsRef.currentVariant = this.currentVariant;
    }
    updateMedia(initialLoad) {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        let mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (this.isStickyForm) {
            const previewImage = this.currentVariant.featured_media.preview_image.src;
            const stickyThumbnail = document.querySelector(`.sticky-cart__thumbnail`);
            if (stickyThumbnail) {
                stickyThumbnail.src = `${previewImage}?width=60`;
                stickyThumbnail.srcset = `${previewImage}?width=60 300w`;
            }
            mediaGallery = document.querySelector('media-gallery');
            mediaId = this.mainFormVariantsRef.dataset.section + '-' + this.currentVariant.featured_media.id;
        }
        const eventSetActiveMedia = new CustomEvent('setActiveMediaTrigger', {
            bubbles: true,
            detail: {
                mediaId: mediaId,
                mediaGallery: mediaGallery,
                initialLoad: initialLoad,
                isStickyForm: this.isStickyForm
            }
        });
        window.addEventListener('DOMContentLoaded', ()=>{
            document.body.dispatchEvent(eventSetActiveMedia);
        });
        if (initialLoad) return;
        document.body.dispatchEvent(eventSetActiveMedia);
    }
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm)=>{
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
        if (this.isStickyForm) {
            if (this.stickyFormRef) this.stickyFormRef.querySelector('input[name="id"]').value = this.currentVariant.id;
        } else this.mainFormRef.querySelector('[data-hidden-variant-input]').value = this.currentVariant.id;
    }
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        if (this.currentVariant && this.currentVariant.available) pickUpAvailability.fetchAvailability(this.currentVariant.id);
        else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }
    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }
    checkIfSectionExists() {
        let sectionId = '';
        if (this.dataset.section === 'false') return sectionId;
        if (this.dataset.section.includes('quick-view')) return '';
        if (this.dataset.originalSection) sectionId = '&section_id=' + this.dataset.originalSection;
        if (this.dataset.section) sectionId = '&section_id=' + this.dataset.section;
        return sectionId;
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${this.checkIfSectionExists()}`).then((response)=>response.text()).then((responseText)=>{
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`price-${this.dataset.productId}`);
            const source = html.getElementById(`price-${this.dataset.productId}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const popupImage = document.querySelector('product-popup .popup-product-img-js');
            if (popupImage && this.currentVariant.featured_image) {
                popupImage.src = this.currentVariant.featured_image.src;
                popupImage.srcset = this.currentVariant.featured_image.src;
            }
            const price = document.getElementById(`price-${this.dataset.productId}`);
            if (price) price.classList.remove('visibility-hidden');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        let addBtnSticky;
        let addBtnTextSticky;
        let addBtnMain;
        let addBtnTextMain;
        if (this.isStickyForm && this.mainFormRef) {
            addBtnMain = this.mainFormRef.querySelector('[name="add"]');
            addBtnTextMain = this.mainFormRef.querySelector('[name="add"] > span');
        } else if (this.stickyFormRef) {
            addBtnSticky = this.stickyFormRef.querySelector('[name="add"]');
            addBtnTextSticky = addBtnSticky.querySelector('[name="add"] > span');
        }
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
            if (addBtnMain) addBtnMain.setAttribute('disabled', 'disabled');
            if (text && addBtnTextMain) addBtnTextMain.textContent = text;
            if (addBtnSticky) addBtnSticky.setAttribute('disabled', 'disabled');
            if (text && addBtnTextSticky) addBtnTextSticky.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
            if (addBtnMain) addBtnMain.removeAttribute('disabled');
            if (addBtnTextMain) addBtnTextMain.textContent = window.variantStrings.addToCart;
            if (addBtnSticky) addBtnSticky.removeAttribute('disabled');
            if (addBtnTextSticky) addBtnTextSticky.textContent = window.variantStrings.addToCart;
        }
        if (!modifyClass) return;
    }
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
        let addBtnSticky;
        let addBtnTextSticky;
        let addBtnMain;
        let addBtnTextMain;
        if (this.isStickyForm) {
            addBtnMain = this.mainFormRef.querySelector('[name="add"]');
            addBtnTextMain = this.mainFormRef.querySelector('[name="add"] > span');
            addBtnTextMain.textContent = window.variantStrings.unavailable;
        } else if (this.stickyFormRef) {
            addBtnSticky = this.stickyFormRef.querySelector('[name="add"]');
            addBtnTextSticky = addBtnSticky.querySelector('[name="add"] > span');
            addBtnTextSticky.textContent = window.variantStrings.unavailable;
        }
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('variant-selects', $661b1f04b5689b56$var$VariantSelects);
class $661b1f04b5689b56$var$VariantRadios extends $661b1f04b5689b56$var$VariantSelects {
    constructor(){
        super();
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset)=>{
            return Array.from(fieldset.querySelectorAll('input')).find((radio)=>radio.checked).value;
        });
        if (this.isStickyForm) return;
        else if (this.stickyFormVariantsRef) {
            this.stickyFormVariantsRef.options = this.options;
            const allSelects = this.stickyFormVariantsRef.querySelectorAll('select');
            if (allSelects.length > 0) this.stickyFormVariantsRef.options.forEach((option, index)=>{
                allSelects[index].value = option;
            });
        }
    }
}
customElements.define('variant-radios', $661b1f04b5689b56$var$VariantRadios);


// getCookie
/**
 * Utilss: Cookies
 * ------------------------------------------------------------------------------
 * Karmoon cookie functions.
 *
 * @namespace cookies
 */ /**
 * Set a cookie.
 * @param {cname} string - Cookie name.
 * @param {cvalue} string - Cookie value.
 * @param {exdays} Int - Number of days until Cookie expires.
 */ function $a5ea67171005546a$var$cookies() {
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 86400000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    /**
   * Check is a cookie exists.
   * @param {cname} string - Cookie name.
   */ function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }
}
document.addEventListener('DOMContentLoaded', function() {
    $a5ea67171005546a$var$cookies();
});
/**
 * Helper: Cookies from global.js
 * ------------------------------------------------------------------------------
 * Karmoon cookie functions.
 *
 * @namespace cookies
 */ /**
 * Set a cookie.
 * @param {cname} string - Cookie name.
 * @param {cvalue} string - Cookie value.
 * @param {exdays} Int - Number of days until Cookie expires.
 */ function $a5ea67171005546a$export$110700823644f4a6(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
/**
 * Check is a cookie exists.
 * @param {cname} string - Cookie name.
 */ function $a5ea67171005546a$export$4be65e66cfa2648a(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == ' ')c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}



class $37bf41cdead1f49c$var$ModalDialog extends HTMLElement {
    constructor(){
        super();
        if (this.querySelectorAll('[id^="ModalClose-"]').length > 0) this.querySelectorAll('[id^="ModalClose-"]').forEach((closeBtn)=>{
            closeBtn.addEventListener('click', this.hide.bind(this, false));
        });
        if (this.querySelector('[id^="ModalCloseNoThanks-"]')) this.querySelector('[id^="ModalCloseNoThanks-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        if (this.classList.contains('media-modal')) this.addEventListener('pointerup', (event)=>{
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
        else this.addEventListener('click', (event)=>{
            if (event.target === this) this.hide();
        });
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    }
    show(opener1) {
        this.openedBy = opener1;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        (0, $3fb125f96e5f3e5f$export$df87d1b3660dd9f7)();
    }
    hide() {
        this.openedBy = opener;
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(this.openedBy);
        (0, $3fb125f96e5f3e5f$export$df87d1b3660dd9f7)();
        if (typeof this.removeForm === 'function') this.removeForm();
    }
}
customElements.define('modal-dialog', $37bf41cdead1f49c$var$ModalDialog);
/* ============================================================================
  Social Feed Modal - Extends default Popup
============================================================================== */ class $37bf41cdead1f49c$var$SocialFeedPopup extends $37bf41cdead1f49c$var$ModalDialog {
    constructor(){
        super();
        this.activePost;
        this.addEventListener('click', (e)=>{
            if (e.target.closest('.js-sm-feed-popup-left-arrow')) this.switchSlides('left');
            if (e.target.closest('.js-sm-feed-popup-right-arrow')) this.switchSlides('right');
        });
    }
    setActivePost(postId) {
        const relevantPost = this.querySelector(`[data-post-id="${postId}"]`);
        if (!relevantPost) return;
        if (this.activePost) this.activePost.classList.remove('is-active');
        relevantPost.classList.add('is-active');
        this.activePost = relevantPost;
        (0, $3fb125f96e5f3e5f$export$df87d1b3660dd9f7)();
        this.playVideo();
    }
    playVideo() {
        const video = this.activePost.querySelector('video');
        if (!video) return;
        setTimeout(()=>{
            video.play();
        }, 400);
    }
    pauseVideo() {
        const video = this.activePost.querySelector('video');
        if (!video) return;
        video.pause();
    }
    switchSlides(direction = 'right') {
        const newPost = direction === 'left' ? this.activePost.previousElementSibling : this.activePost.nextElementSibling;
        this.pauseVideo();
        this.activePost.classList.remove('is-active');
        newPost.classList.add('is-active');
        this.activePost = newPost;
        this.playVideo();
    }
}
customElements.define('social-feed-popup', $37bf41cdead1f49c$var$SocialFeedPopup);
/* ============================================================================
  Gallery Viewer Modal - Extends default Popup
============================================================================== */ class $37bf41cdead1f49c$var$GalleryViewer extends $37bf41cdead1f49c$var$ModalDialog {
    constructor(){
        super();
        this.carousel = this.querySelector('embla-component');
    }
    setActiveImage(position) {
        setTimeout(()=>{
            this.carousel.slideToIndex(position);
        }, 100);
    }
}
customElements.define('gallery-viewer', $37bf41cdead1f49c$var$GalleryViewer);
/* ============================================================================
  Quick view modal - Extends default Popup
============================================================================== */ class $37bf41cdead1f49c$var$ProductPopup extends $37bf41cdead1f49c$var$ModalDialog {
    constructor(){
        super();
    }
    static get observedAttributes() {
        return [
            'data-id'
        ];
    }
    getForm(_handle, _id) {
        const shopifyProductUrl = `/products/${_handle}?view=quick-view`;
        fetch(shopifyProductUrl).then((res)=>{
            return res.text();
        }).then((res)=>{
            let parser = new DOMParser();
            let doc = parser.parseFromString(res, 'text/html');
            let productForm = doc.querySelector('.product-popup-inner');
            const productPopup = document.querySelector('product-popup');
            productPopup.setAttribute('data-id', _id);
            const quickViewCard = document.querySelector('product-popup .quick-view-card');
            if (quickViewCard) quickViewCard.appendChild(productForm);
            quickViewCard.focus();
            quickViewCard.querySelector('[id^="popup-closer-"]').addEventListener('click', ()=>{
                productPopup.hide();
            });
        }).catch((err)=>{});
    }
    removeForm() {
        const quickViewCard = document.querySelector('product-popup .quick-view-card');
        if (quickViewCard) quickViewCard.lastElementChild.remove();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        let _id = this.getAttribute('data-id');
    }
}
customElements.define('product-popup', $37bf41cdead1f49c$var$ProductPopup);
/* ============================================================================
  Modal Opener
============================================================================== */ class $37bf41cdead1f49c$var$ModalOpener extends HTMLElement {
    constructor(){
        super();
        const button = this.querySelector('[id^="ModalOpenerBtn-"]');
        if (!button) return;
        // if keybaord has focused on the modal trigger
        button.addEventListener('keydown', (e)=>{
            if (e.code == "Enter") document.activeElement.click();
        });
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (!modal) return;
            // checking for the social feed popup that needs to show correct content
            if (modal.classList.contains('social-feed-popup')) {
                const postId = button.getAttribute('data-post-id');
                if (button.getAttribute('data-post-id') === 'post-placeholder') return;
                modal.setActivePost(postId);
            }
            // checking for the PDP gallery viewer that needs to show correct content
            if (modal.classList.contains('gallery-viewer')) {
                const imagePosition = +button.getAttribute('data-index');
                modal.setActiveImage(imagePosition);
            }
            // checking for the product quick view that needs to render correct form
            if (modal.classList.contains('product-popup')) {
                e.preventDefault();
                modal.getForm(this.getAttribute('data-handle'), this.getAttribute('data-id'));
            }
            modal.show(button);
        });
    }
}
customElements.define('modal-opener', $37bf41cdead1f49c$var$ModalOpener);
/* ============================================================================
  Deferred Media
============================================================================== */ class $37bf41cdead1f49c$var$DeferredMedia extends HTMLElement {
    constructor(){
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }
    loadContent(focus = true) {
        (0, $3fb125f96e5f3e5f$export$df87d1b3660dd9f7)();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
            this.setAttribute('loaded', true);
            this.classList.add('is-active');
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) // force autoplay for safari
            deferredElement.play();
            this.addEventListeners();
        } else {
            this.toggleVideoStateHandler('PLAY');
            this.playVideo();
        }
    }
    addEventListeners() {
        const video = this.querySelector('video');
        video?.addEventListener('pause', (e)=>{
            this.toggleVideoStateHandler('PAUSE', video);
        });
        video?.addEventListener('ended', (e)=>{
            this.toggleVideoStateHandler('END', video);
        });
    }
    toggleVideoStateHandler(action, video) {
        if (action === 'PLAY') this.classList.add('is-active');
        else if (action === 'PAUSE' || action === 'END') this.classList.remove('is-active');
    }
    playVideo() {
        const type = this.getAttribute('data-type');
        if (type === 'youtube') this.querySelector('.js-youtube')?.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        else if (type == 'video') this.querySelector('video')?.play();
        else if (type == 'vimeo') this.querySelector('.js-vimeo')?.contentWindow.postMessage('{"method":"play"}', '*');
        else console.error('No video type specified');
    }
}
customElements.define('deferred-media', $37bf41cdead1f49c$var$DeferredMedia);
/* ============================================================================
  Signup Modal
============================================================================== */ if (!customElements.get('signup-modal')) customElements.define('signup-modal', class SignupModal extends $37bf41cdead1f49c$var$ModalDialog {
    constructor(){
        super();
        this.modalClose = this.querySelector('[js-modal="close"]');
        // Grab cookie values on mount
        // Shopify generated
        // This custom el
        const hasModalClosed = this.getCookie('signup-modal-closed');
        if (window.designMode.enabled !== 'true') {
            this.delay = parseInt(this.dataset.delay) || 9000;
            this.checkSubmission(hasModalClosed);
            this.addEventListeners();
        } else this.addEventListeners();
        this.forceOpen();
    }
    /**
       * Check if the form has been submitted
       * This is checking for the URL param ?customer_posted=true
       */ checkSubmission(l, c) {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const customerPosted = urlParams.get('customer_posted');
        if (!customerPosted) {
            this.checkCookie(l, c);
            return;
        }
        if (customerPosted === 'true') {
            this.show();
            setCookie('signup-modal-closed', 'true', 340);
            this.successMessage();
        } else this.checkCookie(l, c);
    }
    /**
       * Check if the cookie has been set
       * If it hasn't been set, show the modal
       *
       * @param {String} l - Locale (Shopiy) - Shopify default predicted locale code
       * @param {String} c - Closed - Has the signup modal closed?
       */ checkCookie() {
        if (this.getCookie('signup-modal-closed') == undefined) setTimeout(()=>{
            this.show();
        }, this.delay);
    }
    successMessage() {
        const items = document.querySelectorAll('.js-sign-up-success');
        items.forEach((item)=>{
            item.classList.add('is-hidden');
        });
    }
    hide() {
        super.hide();
        this.setCookie('signup-modal-closed', 'true', 30);
        this.videoStop();
    }
    show(opener1) {
        super.show(opener1);
        this.videoPlay();
    }
    videoPlay() {
        const video = this.querySelector('video');
        if (video) video.play();
    }
    videoStop() {
        const video = this.querySelector('video');
        if (video) video.pause();
    }
    /**
       * This is for the theme editor
       * This will display the modal when the user is editing the section
       */ addEventListeners() {
        document.addEventListener('shopify:section:select', (event)=>{
            this.hide();
            const id = event.detail.sectionId;
            if (id != 'sign-up-modal') return;
            const opener1 = `#SignupModal-${id} button`;
            this.show(opener1);
        });
        document.addEventListener('shopify:section:deselect', (event)=>{
            this.hide();
        });
        this.modalClose.addEventListener('click', ()=>{
            this.hide();
        });
        // on key escape close modal
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') this.hide();
        });
    }
    forceOpen() {
        const urlParams = new URLSearchParams(window.location.search);
        const signup_modal = urlParams.get('signup_modal');
        const form_type = urlParams.get('form_type');
        // if url contains /challenge
        if (window.location.pathname.includes('/challenge')) return;
        if (signup_modal === 'true' || form_type === 'customer') this.show();
    }
    getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }
});




document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-block__item');
    accordionItems.forEach((item)=>{
        const heading = item.querySelector('.accordion-block__heading');
        const content = item.querySelector('.accordion-block__content');
        if (!heading || !content) return;
        content.style.display = 'none';
        heading.addEventListener('click', function() {
            const isOpen = item.classList.contains('active');
            accordionItems.forEach((innerItem)=>{
                const innerContent = innerItem.querySelector('.accordion-block__content');
                if (innerContent) innerContent.style.display = 'none';
                innerItem.classList.remove('active');
            });
            if (!isOpen) {
                content.style.display = 'block';
                item.classList.add('active');
            }
        });
    });
});


function $d65d5652050191ad$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $d65d5652050191ad$var$isString(subject) {
    return typeof subject === 'string';
}
function $d65d5652050191ad$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $d65d5652050191ad$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $d65d5652050191ad$var$mathAbs(n) {
    return Math.abs(n);
}
function $d65d5652050191ad$var$mathSign(n) {
    return Math.sign(n);
}
function $d65d5652050191ad$var$deltaAbs(valueB, valueA) {
    return $d65d5652050191ad$var$mathAbs(valueB - valueA);
}
function $d65d5652050191ad$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($d65d5652050191ad$var$mathAbs(valueB) <= $d65d5652050191ad$var$mathAbs(valueA)) return 0;
    const diff = $d65d5652050191ad$var$deltaAbs($d65d5652050191ad$var$mathAbs(valueB), $d65d5652050191ad$var$mathAbs(valueA));
    return $d65d5652050191ad$var$mathAbs(diff / valueB);
}
function $d65d5652050191ad$var$arrayKeys(array) {
    return $d65d5652050191ad$var$objectKeys(array).map(Number);
}
function $d65d5652050191ad$var$arrayLast(array) {
    return array[$d65d5652050191ad$var$arrayLastIndex(array)];
}
function $d65d5652050191ad$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $d65d5652050191ad$var$arrayIsLastIndex(array, index) {
    return index === $d65d5652050191ad$var$arrayLastIndex(array);
}
function $d65d5652050191ad$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $d65d5652050191ad$var$objectKeys(object) {
    return Object.keys(object);
}
function $d65d5652050191ad$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $d65d5652050191ad$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $d65d5652050191ad$var$isObject(valueA) && $d65d5652050191ad$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $d65d5652050191ad$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $d65d5652050191ad$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $d65d5652050191ad$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($d65d5652050191ad$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $d65d5652050191ad$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $d65d5652050191ad$var$EventStore();
    const timeStep = 1000 / 60;
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationFrame) return;
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            update();
            lag -= timeStep;
        }
        const lagOffset = $d65d5652050191ad$var$mathAbs(lag / timeStep);
        render(lagOffset);
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $d65d5652050191ad$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $d65d5652050191ad$var$Limit(min = 0, max = 0) {
    const length = $d65d5652050191ad$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $d65d5652050191ad$var$Counter(max, start, loop) {
    const { constrain: constrain } = $d65d5652050191ad$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $d65d5652050191ad$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $d65d5652050191ad$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $d65d5652050191ad$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $d65d5652050191ad$var$EventStore();
    const dragEvents = $d65d5652050191ad$var$EventStore();
    const goToNextThreshold = $d65d5652050191ad$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($d65d5652050191ad$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($d65d5652050191ad$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $d65d5652050191ad$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $d65d5652050191ad$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $d65d5652050191ad$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$d65d5652050191ad$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $d65d5652050191ad$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $d65d5652050191ad$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(1);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $d65d5652050191ad$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        pointerDown: pointerDown,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($d65d5652050191ad$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $d65d5652050191ad$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $d65d5652050191ad$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $d65d5652050191ad$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    ownerWindow.requestAnimationFrame(()=>{
                        emblaApi.reInit();
                        eventHandler.emit('resize');
                    });
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if (destroyed) return;
            if ($d65d5652050191ad$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        const observeNodes = [
            container
        ].concat(slides);
        observeNodes.forEach((node)=>resizeObserver.observe(node));
    }
    function destroy() {
        if (resizeObserver) resizeObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$ScrollBody(location, offsetLocation, target, baseDuration, baseFriction) {
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            location.set(target);
            directionDiff = diff;
        } else {
            bodyVelocity += diff / scrollDuration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $d65d5652050191ad$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $d65d5652050191ad$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $d65d5652050191ad$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $d65d5652050191ad$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(offsetLocation.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(offsetLocation.get()) ? 'min' : 'max';
        const diffToEdge = $d65d5652050191ad$var$mathAbs(limit[edge] - offsetLocation.get());
        const diffToTarget = target.get() - offsetLocation.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $d65d5652050191ad$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $d65d5652050191ad$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $d65d5652050191ad$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $d65d5652050191ad$var$deltaAbs(bound, snap) < 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $d65d5652050191ad$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $d65d5652050191ad$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $d65d5652050191ad$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $d65d5652050191ad$var$arrayLast(scrollSnaps);
    const limit = $d65d5652050191ad$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $d65d5652050191ad$var$ScrollLooper(contentSize, limit, offsetLocation, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $d65d5652050191ad$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(offsetLocation.get());
        if (direction === -1) return reachedMin(offsetLocation.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $d65d5652050191ad$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $d65d5652050191ad$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$d65d5652050191ad$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($d65d5652050191ad$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$d65d5652050191ad$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $d65d5652050191ad$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $d65d5652050191ad$var$arrayLast(groups[0]) + 1;
                return $d65d5652050191ad$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $d65d5652050191ad$var$arrayLastIndex(slideIndexes) - $d65d5652050191ad$var$arrayLast(groups)[0] + 1;
                return $d65d5652050191ad$var$arrayFromNumber(range, $d65d5652050191ad$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $d65d5652050191ad$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$d65d5652050191ad$var$mathAbs(a) - $d65d5652050191ad$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$d65d5652050191ad$var$mathAbs(d1.diff) - $d65d5652050191ad$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return targets[0];
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$d65d5652050191ad$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $d65d5652050191ad$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $d65d5652050191ad$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $d65d5652050191ad$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore) {
    let lastTabPressTime = 0;
    function init() {
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach(addSlideFocusEvent);
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    function addSlideFocusEvent(slide) {
        const focus = ()=>{
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            root.scrollLeft = 0;
            const index = slides.indexOf(slide);
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$d65d5652050191ad$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
        };
        eventStore.add(slide, 'focus', focus, {
            passive: true,
            capture: true
        });
    }
    const self = {
        init: init
    };
    return self;
}
function $d65d5652050191ad$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $d65d5652050191ad$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $d65d5652050191ad$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(axis.direction(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $d65d5652050191ad$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides) {
    const roundingSafety = 0.5;
    const ascItems = $d65d5652050191ad$var$arrayKeys(slideSizesWithGaps);
    const descItems = $d65d5652050191ad$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $d65d5652050191ad$var$Vector1D(-1),
                translate: $d65d5652050191ad$var$Translate(axis, slides[index]),
                target: ()=>offsetLocation.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $d65d5652050191ad$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($d65d5652050191ad$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $d65d5652050191ad$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $d65d5652050191ad$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $d65d5652050191ad$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($d65d5652050191ad$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($d65d5652050191ad$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $d65d5652050191ad$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $d65d5652050191ad$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $d65d5652050191ad$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $d65d5652050191ad$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $d65d5652050191ad$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $d65d5652050191ad$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $d65d5652050191ad$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $d65d5652050191ad$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $d65d5652050191ad$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $d65d5652050191ad$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $d65d5652050191ad$var$PercentOfView(viewSize);
    const alignment = $d65d5652050191ad$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $d65d5652050191ad$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $d65d5652050191ad$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $d65d5652050191ad$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$d65d5652050191ad$var$arrayLast(snaps) + $d65d5652050191ad$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $d65d5652050191ad$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $d65d5652050191ad$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $d65d5652050191ad$var$Counter($d65d5652050191ad$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $d65d5652050191ad$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, options: { loop: loop } }, lagOffset)=>{
        const velocity = scrollBody.velocity();
        const hasSettled = scrollBody.settled();
        if (hasSettled && !dragHandler.pointerDown()) {
            animation.stop();
            eventHandler.emit('settle');
        }
        if (!hasSettled) eventHandler.emit('scroll');
        offsetLocation.set(location.get() - velocity + velocity * lagOffset);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = $d65d5652050191ad$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (lagOffset)=>render(engine, lagOffset));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $d65d5652050191ad$var$Vector1D(startLocation);
    const offsetLocation = $d65d5652050191ad$var$Vector1D(startLocation);
    const target = $d65d5652050191ad$var$Vector1D(startLocation);
    const scrollBody = $d65d5652050191ad$var$ScrollBody(location, offsetLocation, target, duration, friction);
    const scrollTarget = $d65d5652050191ad$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $d65d5652050191ad$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $d65d5652050191ad$var$ScrollProgress(limit);
    const eventStore = $d65d5652050191ad$var$EventStore();
    const slidesInView = $d65d5652050191ad$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $d65d5652050191ad$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $d65d5652050191ad$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $d65d5652050191ad$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $d65d5652050191ad$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        options: options,
        resizeHandler: $d65d5652050191ad$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $d65d5652050191ad$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $d65d5652050191ad$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $d65d5652050191ad$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $d65d5652050191ad$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $d65d5652050191ad$var$Translate(axis, container)
    };
    return engine;
}
function $d65d5652050191ad$var$EventHandler() {
    const listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on
    };
    return self;
}
const $d65d5652050191ad$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true
};
function $d65d5652050191ad$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $d65d5652050191ad$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $d65d5652050191ad$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$d65d5652050191ad$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $d65d5652050191ad$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $d65d5652050191ad$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $d65d5652050191ad$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $d65d5652050191ad$var$EventStore();
    const eventHandler = $d65d5652050191ad$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($d65d5652050191ad$var$defaultOptions, $d65d5652050191ad$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $d65d5652050191ad$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $d65d5652050191ad$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $d65d5652050191ad$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init();
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$d65d5652050191ad$export$2e2bcd8739ae039.globalOptions = undefined;




class $b1c2252fe2969ef5$var$EmblaComponent extends HTMLElement {
    constructor(){
        super();
        this.emblaApi;
        this.emblaApiThumbs;
        this.emblaNode = this.querySelector('.embla');
        this.emblaSlide = this.querySelectorAll('.embla__slide');
        this.emblaThumbs = this.querySelector('.embla-thumbs');
        this.viewportNode = this.querySelector('.embla__viewport');
        this.viewportNodeThumbs = this.querySelector('.embla-thumbs__viewport');
        this.prevBtn = this.querySelector('.embla__button--prev');
        this.nextBtn = this.querySelector('.embla__button--next');
        this.prevBtnThumbs = this.querySelector('.embla__button-thumb--prev');
        this.nextBtnThumbs = this.querySelector('.embla__button-thumb--next');
        this.dotsNode = this.querySelector('.embla__dots');
        this.fractions = this.querySelector('.embla-custom-fractions');
        this.progressNode = this.querySelector('.embla__progress__bar');
        this.options = this.returnConfig();
        this.optionsThumbs = this.returnThumbsConfig();
        document.addEventListener('DOMContentLoaded', (e)=>{
            this.initEmbla();
            this.handleSelect();
            this.emblaApi.on('select', ()=>this.handleSelect());
        });
        if (this.emblaNode.getAttribute('data-active-on-click') == 'true') this.activeOnClick();
        if (window.designMode.enabled === 'true') document.addEventListener('shopify:section:load', (event)=>{
            this.initEmbla();
            this.handleSelect();
            this.emblaApi.on('select', ()=>this.handleSelect());
        });
    }
    initEmbla() {
        const autoplay = this.emblaNode.getAttribute('data-autoplay') === 'true' ? [
            EmblaCarouselAutoplay(this.returnAutoplayConfig())
        ] : null;
        this.emblaApi = (0, $d65d5652050191ad$export$2e2bcd8739ae039)(this.viewportNode, this.options, autoplay);
        if (this.viewportNodeThumbs) this.emblaApiThumbs = (0, $d65d5652050191ad$export$2e2bcd8739ae039)(this.viewportNodeThumbs, this.optionsThumbs);
        if (this.progressNode) {
            const { applyProgress: applyProgress, removeProgress: removeProgress } = $b1c2252fe2969ef5$var$setupProgressBar(this.emblaApi, this.progressNode);
            this.emblaApi.on('init', applyProgress).on('reInit', applyProgress).on('scroll', applyProgress).on('destroy', removeProgress);
        }
        if (this.prevBtn && this.nextBtn) {
            $b1c2252fe2969ef5$var$addPrevNextBtnsClickHandlers(this.emblaApi, this.prevBtn, this.nextBtn);
            $b1c2252fe2969ef5$var$addTogglePrevNextBtnsActive(this.emblaApi, this.prevBtn, this.nextBtn);
        }
        if (this.dotsNode) $b1c2252fe2969ef5$var$addDotBtnsAndClickHandlers(this.emblaApi, this.dotsNode);
        if (this.fractions) $b1c2252fe2969ef5$var$addFactions(this.emblaApi, this.fractions);
        if (this.emblaApiThumbs) {
            $b1c2252fe2969ef5$var$addThumbBtnsClickHandlers(this.emblaApi, this.emblaApiThumbs);
            $b1c2252fe2969ef5$var$addToggleThumbBtnsActive(this.emblaApi, this.emblaApiThumbs);
            if (this.prevBtnThumbs && this.nextBtnThumbs) {
                $b1c2252fe2969ef5$var$addPrevNextBtnsClickHandlers(this.emblaApiThumbs, this.prevBtnThumbs, this.nextBtnThumbs);
                $b1c2252fe2969ef5$var$addTogglePrevNextBtnsActive(this.emblaApiThumbs, this.prevBtnThumbs, this.nextBtnThumbs);
            }
            if (this.emblaThumbs.getAttribute('data-change-slides-on-hover') === 'true') {
                const thumbSlides = this.querySelectorAll('.embla-thumbs__slide');
                if (thumbSlides.length > 0) thumbSlides.forEach((slide)=>{
                    slide.addEventListener('mouseenter', (e)=>{
                        this.emblaApi.scrollTo(+slide.getAttribute('data-slide-index'));
                    });
                });
            }
        }
    }
    returnConfig() {
        return {
            align: this.emblaNode.getAttribute('data-align') || 'center',
            loop: this.emblaNode.getAttribute('data-loop') === 'true' ? true : false,
            slidesToScroll: +this.emblaNode.getAttribute('data-slides-to-scroll') || 'auto',
            startIndex: +this.emblaNode.getAttribute('data-start-index') || 0,
            containScroll: 'trimSnaps',
            axis: this.emblaNode.getAttribute('data-axis') || 'x',
            duration: +this.emblaNode.getAttribute('data-duration') || 25,
            inViewThreshold: 1,
            watchDrag: this.emblaNode.getAttribute('data-enable-drag') === 'false' ? false : true,
            breakpoints: {
                ...this.returnBreakpoints()
            }
        };
    }
    returnAutoplayConfig() {
        return {
            delay: +this.emblaNode.getAttribute('data-autoplay-speed') || 4000
        };
    }
    returnThumbsConfig() {
        if (!this.viewportNodeThumbs) return;
        return {
            containScroll: 'keepSnaps',
            axis: this.emblaThumbs.getAttribute('data-axis') || 'x',
            dragFree: true,
            align: 'start'
        };
    }
    returnBreakpoints() {
        return {
            '(min-width: 990px)': this.emblaNode.getAttribute('data-desktop-vertical') === 'true' ? {
                axis: 'y'
            } : null
        };
    }
    handleSelect() {
        this.setActiveSlide();
        this.emblaNode.setAttribute('data-active-slide', this.emblaApi.slidesInView(true));
        if (this.extraSlideEls) this.extraSlideEls.showExtraSlideEl(this.emblaApi.slidesInView(true));
        (0, $3fb125f96e5f3e5f$export$df87d1b3660dd9f7)();
        const fractionDisplay = this.querySelector(".embla__fraction");
        if (fractionDisplay) {
            const selectedIndex = this.emblaApi.selectedScrollSnap() + 1; // Convert to 1-based index
            const totalSlides = this.emblaApi.slideNodes().length;
            fractionDisplay.textContent = `${selectedIndex} / ${totalSlides}`;
        }
    }
    setActiveSlide() {
        this.emblaNode.querySelectorAll('.is-active')?.forEach((el)=>el.classList.remove('is-active'));
        this.emblaNode.querySelector(`[data-slide-index="${this.emblaApi.selectedScrollSnap()}"]`)?.classList.add('is-active');
    }
    restart() {
        this.initEmbla();
    }
    slideToIndex(index) {
        this.emblaApi.scrollTo(index);
    }
    activeOnClick() {
        this.emblaSlide.forEach((element)=>{
            element.addEventListener('click', ()=>{
                this.slideToIndex(element.dataset.slideIndex);
            });
        });
    }
}
customElements.define('embla-component', $b1c2252fe2969ef5$var$EmblaComponent);
/* ============================================================================
  Embla Extras
============================================================================== */ const $b1c2252fe2969ef5$var$addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn)=>{
    const scrollPrev = ()=>emblaApi.scrollPrev();
    const scrollNext = ()=>emblaApi.scrollNext();
    prevBtn.addEventListener('click', scrollPrev, false);
    nextBtn.addEventListener('click', scrollNext, false);
    return ()=>{
        prevBtn.removeEventListener('click', scrollPrev, false);
        nextBtn.removeEventListener('click', scrollNext, false);
    };
};
const $b1c2252fe2969ef5$var$addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn)=>{
    const togglePrevNextBtnsState = ()=>{
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
        else prevBtn.setAttribute('disabled', 'disabled');
        if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
        else nextBtn.setAttribute('disabled', 'disabled');
    };
    emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
    return ()=>{
        prevBtn.removeAttribute('disabled');
        nextBtn.setAttribute('disabled', 'disabled');
    };
};
const $b1c2252fe2969ef5$var$addDotBtnsAndClickHandlers = (emblaApi, dotsNode)=>{
    let dotNodes = [];
    const addDotBtnsWithClickHandlers = ()=>{
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(()=>'<button aria-label="carousel pagination button" class="embla__dot" type="button"></button>').join('');
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
        dotNodes.forEach((dotNode, index)=>{
            dotNode.addEventListener('click', ()=>emblaApi.scrollTo(index), false);
        });
    };
    const toggleDotBtnsActive = ()=>{
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('embla__dot--selected');
        dotNodes[selected].classList.add('embla__dot--selected');
    };
    emblaApi.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);
    return ()=>{
        dotsNode.innerHTML = '';
    };
};
const $b1c2252fe2969ef5$var$addFactions = (emblaApi, fractions)=>{
    // Function to update fractions text
    const updateFractionsText = ()=>{
        const selectedIndex = emblaApi.selectedScrollSnap() + 1; // +1 for 1-based index
        const totalSlides = emblaApi.slideNodes().length;
        if (fractions) fractions.innerText = `${selectedIndex}/${totalSlides}`;
    };
    if (emblaApi) {
        // Update fractions text initially
        updateFractionsText();
        // Listen for slide change events
        emblaApi.on('select', ()=>{
            updateFractionsText();
        });
    }
};
const $b1c2252fe2969ef5$var$addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map((_, index)=>()=>emblaApiMain.scrollTo(index));
    slidesThumbs.forEach((slideNode, index)=>{
        slideNode.addEventListener('click', scrollToIndex[index], false);
    });
    return ()=>{
        slidesThumbs.forEach((slideNode, index)=>{
            slideNode.removeEventListener('click', scrollToIndex[index], false);
        });
    };
};
const $b1c2252fe2969ef5$var$addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const toggleThumbBtnsState = ()=>{
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
        const previous = emblaApiMain.previousScrollSnap();
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[previous]?.classList.remove('embla-thumbs__slide--selected');
        slidesThumbs[selected]?.classList.add('embla-thumbs__slide--selected');
    };
    emblaApiMain.on('select', toggleThumbBtnsState);
    emblaApiThumb.on('init', toggleThumbBtnsState);
    return ()=>{
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected');
    };
};
const $b1c2252fe2969ef5$var$setupProgressBar = (emblaApi, progressNode)=>{
    const applyProgress = ()=>{
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
        progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
    };
    const removeProgress = ()=>{
        progressNode.removeAttribute('style');
    };
    return {
        applyProgress: applyProgress,
        removeProgress: removeProgress
    };
};


class $73a3627acd272630$var$StickyCart extends HTMLElement {
    constructor(){
        super();
        this.initialLoad = true;
        this.stickyCartTrigger = document.querySelector('sticky-cart-trigger');
        this.body = document.querySelector('body');
        this.listReference = this.querySelector(`[js-sticky-cart="list-ref"]`);
        if (this.listReference) this.listReference.addEventListener('click', (e)=>{
            this.renderOptions();
        });
        if (!this.stickyCartTrigger) return;
        this.addEventListener('transitionend', ()=>{
            if (!this.classList.contains('is-visible')) this.classList.remove('is-sticky');
        });
        window.addEventListener('resize', ()=>{
            this.handleTopPosition();
        });
        // list to dispatch closeBar event
        document.addEventListener('closeBar', ()=>{
            this.forceCloseBar();
        });
        document.addEventListener('openBar', ()=>{
            this.forceOpenBar();
        });
        this.initObserver();
    }
    static get observedAttributes() {
        return [
            'data-open'
        ];
    }
    initObserver() {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
        };
        const observer = new IntersectionObserver(this.handleStickyCart.bind(this), options);
        observer.observe(this.stickyCartTrigger);
    }
    handleStickyCart() {
        const triggerCoordsY = this.stickyCartTrigger.getBoundingClientRect().top;
        if (triggerCoordsY < 0) {
            this.classList.add('is-sticky');
            this.classList.add('is-visible');
            this.body.style.paddingBottom = this.getBoundingClientRect().height + 'px';
            this.handleTopPosition();
        } else {
            this.classList.remove('is-visible');
            this.body.style.paddingBottom = '0px';
        }
    }
    forceCloseBar() {
        this.classList.add('is-forced-close');
        this.body.style.paddingBottom = '0px';
    }
    forceOpenBar() {
        this.classList.remove('is-forced-close');
        this.body.style.paddingBottom = this.getBoundingClientRect().height + 'px';
    }
    // Add top: 'x' based on the height of the header
    handleTopPosition() {
        const headerHeight = document.querySelector('header').offsetHeight;
        this.style.top = `${headerHeight}px`;
    }
    renderOptions() {
        this.toggleAttribute('data-open');
        this.classList.toggle('is-open');
    }
}
customElements.define('sticky-cart', $73a3627acd272630$var$StickyCart);
class $73a3627acd272630$var$StickyCartTrigger extends HTMLElement {
    constructor(){
        super();
    }
}
customElements.define('sticky-cart-trigger', $73a3627acd272630$var$StickyCartTrigger);


function $28d3d00c671fbd64$var$handleMenuStates() {
    const links = document.querySelectorAll('.js-menu-item-container');
    if (links.length < 1) return;
    links.forEach((link)=>{
        // Add class when menu opens
        link.addEventListener('mouseenter', ()=>{
            document.body.classList.add('megamenu-open');
        });
        // Remove class when menu closes
        link.addEventListener('mouseleave', (e)=>{
            const activeEl = document.activeElement;
            if (activeEl && activeEl.closest('.js-list-menu')) activeEl.blur();
            // Delay check to allow focus transition
            setTimeout(()=>{
                if (!document.querySelector('.js-menu-item-container:hover')) document.body.classList.remove('megamenu-open');
            }, 50);
        });
    });
}
$28d3d00c671fbd64$var$handleMenuStates();
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".list-menu li").forEach((li)=>{
        if (li.querySelector(".mega-menu__column-content")) li.classList.add("column-content-mega-menu");
    });
});


class $8519c214d97efc5e$var$SideMenu extends HTMLElement {
    constructor(){
        super();
        const button = this.querySelector('.js-show-all');
        const menu = this.querySelector('.js-side-menu-links');
        if (!button) return;
        button.addEventListener('click', ()=>{
            this.classList.toggle('is-active');
        });
    }
}
customElements.define('side-menu', $8519c214d97efc5e$var$SideMenu);


class $330059446cdcf135$var$FreeShippingBar extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            wrapper: '.free-shipping__wrapper',
            bar: '.free-shipping__bar',
            fill: '.free-shipping__fill',
            diff: '.free-shipping__diff',
            diffTxt: '.free-shipping__inactive',
            successTxt: '.free-shipping__active'
        };
        this.load();
        if (window.designMode.enabled === 'true') this.addEventListeners();
    }
    load() {
        const nodeSelectors = {
            wrapper: this.querySelector(this.selectors.wrapper),
            bar: this.querySelector(this.selectors.bar),
            fill: this.querySelector(this.selectors.fill),
            diff: this.querySelector(this.selectors.diff),
            diffTxt: this.querySelector(this.selectors.diffTxt),
            successTxt: this.querySelector(this.selectors.successTxt)
        };
        if (!nodeSelectors.wrapper) return;
        // Get threshold
        let threshold = nodeSelectors.bar.dataset.threshold;
        threshold = threshold * 100;
        threshold = Math.round(threshold * (Shopify.currency.rate || 1));
        // Get current cart total
        let cartTotal = nodeSelectors.bar.dataset.total;
        cartTotal = Number(cartTotal);
        // Calculate percentage
        let percentage = Math.ceil(cartTotal / threshold * 100);
        if (percentage > 100) percentage = 100;
        // Set bar width
        nodeSelectors.fill.style.width = percentage + '%';
        // Get the currency symbol
        const currency = this.querySelector(this.selectors.diff).dataset.currency;
        // Difference text
        let difference = threshold - cartTotal;
        difference = difference / 100;
        nodeSelectors.diffTxt.style.display = 'block';
        nodeSelectors.successTxt.style.display = 'none';
        let diffText = nodeSelectors.diffTxt.innerHTML;
        if (percentage >= 100) {
            nodeSelectors.successTxt.style.display = 'block';
            nodeSelectors.diffTxt.style.display = 'none';
        } else diffText = diffText.replace('{diff}', currency + difference);
        nodeSelectors.diffTxt.innerHTML = diffText;
        nodeSelectors.diff.style.opacity = '1';
    }
    addEventListeners() {
        document.addEventListener('shopify:section:load', (event)=>{
            this.load();
        });
        document.addEventListener('shopify:cart:update', (event)=>{
            this.load();
        });
    }
}
customElements.define('free-shipping-bar', $330059446cdcf135$var$FreeShippingBar);



class $039006ee2db5bddb$var$CartRemoveButton extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('click', (event)=>{
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}
customElements.define('cart-remove-button', $039006ee2db5bddb$var$CartRemoveButton);
class $039006ee2db5bddb$var$CartItems extends HTMLElement {
    constructor(){
        super();
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput)=>total + parseInt(quantityInput.value), 0);
        this.debouncedOnChange = (0, $3fb125f96e5f3e5f$export$61fc7d43ac8f84b0)((event)=>{
            this.onChange(event);
        }, 300);
        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'cart-header--main',
                section: 'main-cart-header',
                selector: 'cart-header'
            }
        ];
    }
    updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map((section)=>section.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {
            ...(0, $3fb125f96e5f3e5f$export$1811237fdf5ac5d)(),
            body: body
        }).then((response)=>{
            return response.text();
        }).then((state)=>{
            const parsedState = JSON.parse(state);
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
            this.getSectionsToRender().forEach((section)=>{
                const sectionElementById = document.getElementById(section.id);
                if (!sectionElementById) return;
                const elementToReplace = sectionElementById.querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            });
            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) cartDrawerWrapper ? (0, $3fb125f96e5f3e5f$export$bec45a54c2e66c22)(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            else if (parsedState.item_count === 0 && cartDrawerWrapper) (0, $3fb125f96e5f3e5f$export$bec45a54c2e66c22)(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            else if (document.querySelector('.cart-item') && cartDrawerWrapper) (0, $3fb125f96e5f3e5f$export$bec45a54c2e66c22)(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            this.disableLoading();
        }).catch(()=>{
            this.querySelectorAll('.loading-overlay').forEach((overlay)=>overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
            this.disableLoading();
        });
    }
    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            lineItemError.querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
            lineItemError.classList.remove('hidden');
        }
        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);
        setTimeout(()=>{
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');
        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
        [
            ...cartItemElements,
            ...cartDrawerItemElements
        ].forEach((overlay)=>overlay.classList.remove('hidden'));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
    disableLoading() {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');
    }
}
customElements.define('cart-items', $039006ee2db5bddb$var$CartItems);
if (!customElements.get('cart-note')) customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('change', (0, $3fb125f96e5f3e5f$export$61fc7d43ac8f84b0)((event)=>{
            const body = JSON.stringify({
                note: event.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...(0, $3fb125f96e5f3e5f$export$1811237fdf5ac5d)(),
                body: body
            });
        }, 300));
    }
});
class $039006ee2db5bddb$var$CartDrawer extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('keyup', (evt)=>evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
        this.updatePaymentIconsIds();
    }
    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event)=>{
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event)=>{
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }
    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(()=>{
            this.classList.add('animate', 'active');
        });
        const productPopup = document.querySelector('product-popup');
        if (productPopup && productPopup.hasAttribute('open')) productPopup.hide();
        this.addEventListener('transitionend', ()=>{
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            (0, $3fb125f96e5f3e5f$export$bec45a54c2e66c22)(containerToTrapFocusOn, focusElement);
        }, {
            once: true
        });
        document.body.classList.add('overflow-hidden');
    }
    close() {
        this.classList.remove('active');
        (0, $3fb125f96e5f3e5f$export$c761a6bf8c4188fe)(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }
    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');
        if (cartDrawerNote.nextElementSibling.getAttribute('id')) cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        cartDrawerNote.addEventListener('click', (event)=>{
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
        cartDrawerNote.parentElement.addEventListener('keyup', (0, $3fb125f96e5f3e5f$export$8321c3cfa751e98e));
    }
    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section)=>{
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            if (sectionElement == null || undefined) return false;
            else sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        setTimeout(()=>{
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
        });
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'product-free-shipping'
            }
        ];
    }
    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
    updatePaymentIconsIds() {
        const paymentIcons = this.querySelectorAll('.js-payment-icon');
        if (paymentIcons.length < 1) return;
        paymentIcons.forEach((icon)=>{
            const id = icon.getAttribute('aria-labelledby');
            icon.setAttribute('aria-labelledby', 'cart-drawer-' + id);
            icon.querySelector('title').id = 'cart-drawer-' + id;
        });
    }
}
customElements.define('cart-drawer', $039006ee2db5bddb$var$CartDrawer);
class $039006ee2db5bddb$var$CartDrawerItems extends $039006ee2db5bddb$var$CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'product-free-shipping',
                section: 'product-free-shipping',
                selector: '.shopify-section'
            }
        ];
    }
}
customElements.define('cart-drawer-items', $039006ee2db5bddb$var$CartDrawerItems);


parcelRequire("aYmkr");
 // document.addEventListener('DOMContentLoaded', function () {
 //   animate().init();
 // });

})();
//# sourceMappingURL=theme.js.map
